<div class="row position-relative h-100" [class.lead-full-page]="isLeadFullPage">
  <!-- One column. The detail tabs and the work tabs are a single row above the content now, so the
       two resizable panels they used to head have nothing left to divide. -->
  <div class="listing-shell {{ mobToggle ? 'px-0' : '' }}">
    <ng-container *ngTemplateOutlet="firstPanel"></ng-container>
    <ng-container *ngTemplateOutlet="secondPanel"></ng-container>
  </div>
</div>

<div class="event_popup_modal">
  <p-dialog
    [(visible)]="event_popup"
    [position]="'center'"
    [styleClass]="'noHeader'"
    [showHeader]="false"
    [style]="{ width: '580px', 'margin-top': '200px' }">
    <div class="row">
      <div class="d-flex justify-content-center">
        <span class="left-box-second d-flex justify-content-center">
          <p class="color-box"></p>
        </span>
        <div class="right-box-prop">
          <h6 class="event-title mb-1">{{ event_popup_detail?.summary?.split('|')[0] }}</h6>
          <p class="f-12">
            {{ event_popup_detail?.time }}
          </p>
        </div>
        <div class="crossiconStyle mr-1 cursor-pointer event_poup_close_btn">
          <img
            [src]="common_images?.delete_icon"
            alt="delete"
            class="p-1 cursor-pointer"
            width="24px"
            (click)="deleteCalendarEvent(event_popup_detail)" />
        </div>
        <div class="crossiconStyle mr-2 cursor-pointer event_poup_close_btn d-flex align-items-center">
          <i class="pi pi-times p-1" (click)="event_popup = false"></i>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="d-flex w-100 mb-2 mt-2">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-bars"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12" [innerHtml]="event_popup_detail?.description"></p>
        </div>
      </div>
      <div class="d-flex w-100">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-bell"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12">30 minutes before</p>
        </div>
      </div>
      <div class="d-flex w-100">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-calendar"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12">
            {{ event_popup_detail?.creator?.full_name ? event_popup_detail?.creator?.full_name : 'Listing' }}
          </p>
        </div>
      </div>
      <div class="d-flex w-100">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-lock"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12 text-capitalize">{{ event_popup_detail?.visibility }}</p>
        </div>
      </div>
    </div>
  </p-dialog>
  <p-dialog
    header="Portal Reminders"
    [showHeader]="true"
    [(visible)]="domain_dialog"
    [draggable]="false"
    [style]="{ width: '25vw', 'margin-top': '300px' }"
    [modal]="true"
    [baseZIndex]="100000"
    [contentStyleClass]="'confirmDeleteViewDialog'">
    <div class="p-modal-body mt-3 p-project-detail-body prop-action-meta" style="position: inherit">
      <div class="col-sm-14 text-left">
        <p>This listing has previously had errors on the below portals.</p>
        <br />
        <ng-container *ngFor="let item of domain_name_list">
          <p>{{ item }}</p>
        </ng-container>
        <br />
        <p>Please ensure all changes are reflected across Remmi and portals before saving.</p>
      </div>
      <div class="mt-3 text-right p-modal-footer">
        <button (click)="domain_dialog = false" class="_cancel-btn mr-2" style="height: 36px; min-height: 36px">Cancel</button>
        <button (click)="domain_dialog = false; saveProperty('update')" class="_primary-btn" style="height: 36px; min-height: 36px">
          Save & Close
        </button>
      </div>
    </div>
  </p-dialog>
</div>

<app-confirmation-dialog #contractDeleteDialog (confirmed)="sendEmail()" [title]="'Present Contracts'">
  <div class="col-sm-12 mt-0">
    <label class="f-14 mb-1">To</label>
    <label for="" style="width: 100%">
      <re-multiselect
        [module]="'contacts'"
        [placeholder]="'Select Contact'"
        [truncate]="25"
        [isMultiple]="false"
        [selected_ids]="contractEmail.to"
        (onUpdate)="onUpdateSelect($event)"
        [isEmail]="true"
        [style]="{ width: '100%' }"></re-multiselect>
    </label>
  </div>
  <div class="col-sm-12 mt-2">
    <label class="f-14 mb-1">From</label>
    <input type="text" name="stakeholder" disabled [(ngModel)]="contractEmail.from" class="_input" />
  </div>
  <div class="col-sm-12 mt-2">
    <label class="f-14 mb-1">Select Template</label>
    <ng-select
      [items]="emailTemplates"
      (change)="getTemplateBody('change')"
      [(ngModel)]="contractEmail.emailTemplate"
      name="emailTemplate"
      bindLabel="name"
      bindValue="_id"
      [searchable]="true"
      [clearable]="false"
      placeholder="Email Template"
      class="_select">
    </ng-select>
  </div>
  <div class="col-sm-12 mt-2">
    <label class="f-14 mb-1">Subject</label>
    <input type="text" name="subject" [(ngModel)]="contractEmail.subject" class="_input" />
  </div>
  <div class="col-sm-12 mt-2">
    <label class="f-14 mb-1">Body</label>
    <ckeditor class="gmail-box" [(ngModel)]="contractEmail.body" [editor]="Editor"> </ckeditor>
  </div>
</app-confirmation-dialog>

<app-confirmation-dialog #soldModalDialog viewonly="true" [title]="'Listing Sold'" primary_btn_name="Save" (canceled)="closeModal()">
  <form [formGroup]="editProperty">
    <div class="modal-body">
      <div class="col-sm-12 mt-0 pl-0 pr-0">
        <p class="mb-1">Date Sold</p>
        <div style="width: 100%">
          <p-calendar
            dateFormat="dd/mm/yy"
            class="my-calendar"
            [firstDayOfWeek]="1"
            class="_input"
            formControlName="soldDate"
            [readonlyInput]="true"></p-calendar>
        </div>
      </div>
      <div class="col-sm-12 mt-2 pl-0 pr-0">
        <p class="mb-1">Sold Price</p>
        <div class="position-relative">
          <input formControlName="soldPrice" style="text-indent: 5px" (keyup)="transformPrice($event, 'soldPrice')" class="_input" />
          <p class="currency-sign" *ngIf="editProperty.controls['soldPrice'].value">$</p>
          <span class="dummy-text" *ngIf="editProperty.controls['soldPrice'].hasError('required')">
            <p class="form-error">Sold Price is required<br /></p>
          </span>
        </div>
        <div class="d-flex">
          <p class="f-12 mb-2 mt-3 pl-0 pr-0 text-nowrap">Disclose Price</p>
          <div class="w-100">
            <p-checkbox class="mb-2 mt-3 pl-0 pr-0 ml-2" formControlName="soldPriceDisplay" [binary]="true"></p-checkbox>
            <span class="dummy-text" *ngIf="editProperty.controls['soldPriceDisplay'].hasError('required')">
              <p class="form-error">Price Display is required<br /></p>
            </span>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button class="_outline-btn mr-2">Save</button>
        <button class="_primary-btn" (click)="soldModalDialog.hide()">Save & Close</button>
      </div>
    </div>
  </form>
</app-confirmation-dialog>

<ng-template #firstPanel>
  <ng-container *ngIf="is_agentModel && loadAdmin; else no_listing_popup">
    <div class="row w-100">
      <ng-container *ngIf="listingDetails">
        <app-listing-preview
          [listingDetails]="listingDetails"
          [imagesPath]="imagesPath"
          [imagesLiteHeight]="imagesLiteHeight"
          [imagesLiteWidth]="imagesLiteWidth"
          [imageHeight]="imageHeight"
          [is_agentModel]="is_agentModel"
          [displayedImages]="displayedImages"
          [dayAgo]="dayAgo.bind(this)"
          [adminView]="adminView.bind(this)"
          [goToPrevious]="goToPrevious.bind(this)"
          [getSliderImageByPath]="getSliderImageByPath.bind(this)"
          [getImagePath]="getImagePath.bind(this)"
          [goToNext]="goToNext.bind(this)"
          [getTimed]="getTimed.bind(this)"
          [shortDetails]="shortDetails"
          [isLongDescription]="isLongDescription"
          [currentIndex]="currentIndex"></app-listing-preview>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #no_listing_popup>
    <div class="col-lg-12 pr-0">
      <div class="position-relative ai-suggestions">
        <p-overlayPanel #op [style]="{ width: '500px' }" [dismissable]="true" [showCloseIcon]="true" appendTo="body">
          <p class="mb-2">You can include instructions or descriptive keywords below to generate better results</p>
          <textarea
            pInputTextarea
            spellcheck="true"
            autoresize="autoResize"
            [(ngModel)]="customWords"
            class="mb-2"
            style="overflow: auto; height: 90px; border-radius: 22px !important"></textarea>
          <button class="ml-auto btn btn-primary" (click)="suggestHeading(); op.hide()">
            <i *ngIf="inCall" class="pi pi-spin pi-spinner"></i><span *ngIf="!inCall">Suggest</span>
          </button>
        </p-overlayPanel>
      </div>
      <div class="position-relative ai-suggestions">
        <p-overlayPanel #op2 [style]="{ width: '500px' }" [dismissable]="true" [showCloseIcon]="true" appendTo="body">
          <p class="mb-2">You can include instructions or descriptive keywords below to generate better results</p>
          <textarea
            pInputTextarea
            spellcheck="true"
            autoresize="autoResize"
            [(ngModel)]="customWords1"
            class="mb-2"
            style="min-height: 90px; max-height: 90px; overflow: auto; height: 90px; border-radius: 22px !important"></textarea>
          <p class="mb-2">Select how many paragraphs to include.</p>
          <ng-select [items]="paras" [(ngModel)]="noPara" (keydown)="onKeydown($event)" class="_select mb-2"></ng-select>
          <p class="mb-2">Select tone</p>
          <ng-select [items]="tones" [(ngModel)]="selectedTone" class="_select mb-2"></ng-select>
          <button class="ml-auto btn btn-primary" (click)="suggestDesc(); op2.hide()">
            <i *ngIf="inCall2" class="pi pi-spin pi-spinner"></i><span *ngIf="!inCall2">Suggest</span>
          </button>
        </p-overlayPanel>
      </div>
      <form [formGroup]="editProperty" class="edit-property-form tabs-wraps pb-5 position-relative">
        <div class="">
          <!-- Page header: thumbnail, address and state, the listing's chips, and the actions. -->
          <header class="lh">
            <div class="lh__thumb">
              <img src="{{ S3Path + imageDisplayPath }}" *ngIf="imageDisplayPath?.length > 0" />
              <div class="lh__thumb-fallback" *ngIf="!imageDisplayPath?.length">
                <img [src]="images?.building_icon" />
              </div>
            </div>
            <div class="lh__main">
              <div class="lh__title-row">
                <div class="searching-address">
                  <div class="col p-0 position-relative">
                    <p
                      *ngIf="!lmService.is_new_listing"
                      class="address-field f-20 _fw-600"
                      (click)="openRightModal(editProperty.controls['property_address'].value, 'edit_property')"
                      [ngClass]="{
                        '_input-error': editProperty.controls['property_address'].hasError('required') && submitted,
                      }">
                      {{ editProperty.controls['property_address']?.value }}
                    </p>
                    <ng-container *ngIf="lmService.is_new_listing == true">
                      <div class="position-relative">
                        <div class="position-relative w-100">
                          <input
                            type="text"
                            formControlName="property_address"
                            (input)="filterPropertyListing()"
                            class="_input-icon"
                            placeholder="Search"
                            [ngClass]="{ invalidField: submitted && editProperty.controls['property_address'].invalid }" />
                          <i class="pi pi-search _search-icon"></i>
                          <i class="pi pi-times _cross-icon" *ngIf="editProperty.controls['property_address'].value" (click)="emptySearch()"></i>
                        </div>
                        <div *ngIf="isSearchTrue" class="listing-search-box">
                          <a href="javascript:void(0)" (click)="createNewProperty()" class="link-color f-12">
                            <i class="fa fa-plus"></i> Create new
                          </a>
                          <i class="pi pi-times close" (click)="isSearchTrue = false; filteredListing = []; filteredProperty = []"></i>
                          <div class="mt-2" *ngIf="filteredListing?.length > 0 || filteredProperty?.length > 0">
                            <div *ngIf="filteredListing?.length > 0" class="mt-2">
                              <p class="search-heading d-flex align-items-center">Listings</p>
                              <div class="loop-item">
                                <div *ngFor="let item of filteredListing">
                                  <div class="item-display" (click)="selectFilterItem(item, 'listing')">
                                    <div *ngIf="item.property_images?.length > 0">
                                      <img
                                        src="{{
                                          item?.property_images[0]?.thumbPath
                                            ? S3Path + item?.property_images[0]?.thumbPath
                                            : S3Path + item?.property_images[0]?.file
                                        }}"
                                        class="yes-images" />
                                    </div>
                                    <div *ngIf="item.property_images?.length <= 0">
                                      <img [src]="common_images?.image_not_found" class="no-list-images" />
                                    </div>
                                    <div class="ml-2 w-100">
                                      <div class="d-flex align-items-center justify-content-between postion-relative">
                                        <p class="_fw-600">
                                          {{ item.property_address.replace('Australia', '') }}
                                        </p>
                                        <p class="f-600 status-style">
                                          {{ item.property_status }}
                                        </p>
                                      </div>
                                      <p class="my-1 f-11 _fw-400">Type: {{ item.type }}</p>
                                      <p class="mb-1 f-11 _fw-400">
                                        {{
                                          item.property_status === 'Sold'
                                            ? 'Sold Date:
                                      ' + (item?.soldDate | date: 'd MMM y')
                                            : 'Listing Created: ' + (item.created_at | date: 'd MMM y')
                                        }}
                                      </p>
                                      <p class="f-11 _fw-400 text-danger">Active listing</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="filteredProperty?.length > 0">
                              <p class="search-heading d-flex align-items-center">Properties</p>
                              <div class="loop-item">
                                <div *ngFor="let item of filteredProperty">
                                  <div class="item-display" (click)="selectFilterItem(item, 'property')">
                                    <div *ngIf="item.property_images?.length > 0">
                                      <img
                                        src="{{
                                          item.property_images[0]?.thumbPath
                                            ? S3Path + item?.property_images[0]?.thumbPath
                                            : S3Path + item?.property_images[0]?.file
                                        }}"
                                        class="yes-images" />
                                    </div>
                                    <div *ngIf="item.property_images?.length <= 0">
                                      <img [src]="common_images?.image_not_found" class="no-list-images" />
                                    </div>
                                    <div class="ml-2 w-100">
                                      <div class="d-flex align-items-center justify-content-between postion-relative">
                                        <p class="_fw-600">
                                          {{ item.property_address.replace('Australia', '') }}
                                        </p>
                                      </div>
                                      <p class="mt-2 f-11 _fw-400">Type: {{ item.type }}</p>
                                      <p class="mt-1 f-11 _fw-400">Created Date: {{ item.created_at | date: 'd MMM y' }}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="previousListing?.length > 0">
                          <div
                            *ngIf="
                              lmService.listing_show_div == 'add_listing_from_property' ||
                              lmService.listing_show_div == 'add_listing_property' ||
                              lmService.listing_show_div == 'add_listing_property_listing'
                            ">
                            <ng-select
                              class="_select my-2"
                              formControlName="prevproperty"
                              [ngClass]="{
                                '_input-error': editProperty.controls['prevproperty'].hasError('required') && submitted,
                              }"
                              [items]="previousListing"
                              bindLabel="property_address"
                              bindValue="_id"
                              [searchable]="true"
                              [clearable]="false"
                              placeholder="Previous Listing Data"
                              (change)="patchPrevListing('patch')">
                              <ng-template ng-option-tmp let-item="item">
                                <div class="d-flex align-items-center justify-content-between">
                                  <span>{{ item.property_address }}</span>
                                  <span *ngIf="item.created_at">Created: {{ item.created_at | date: 'd MMM y' }}</span>
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </ng-container>
                        <div class="d-flex flex-wrap gap-3 mt-2" *ngIf="previousListing?.length > 0 || previousListingDetail">
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Images</p>
                            <div class="SP-switch ml-3">
                              <p-inputSwitch
                                [(ngModel)]="isImage"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="patchPrevListing('image')"></p-inputSwitch>
                            </div>
                          </div>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Agent</p>
                            <div class="SP-switch ml-3">
                              <p-inputSwitch
                                [(ngModel)]="isAgent"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="patchPrevListing('agent')"></p-inputSwitch>
                            </div>
                          </div>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Price</p>
                            <div class="SP-switch ml-3">
                              <p-inputSwitch
                                [(ngModel)]="isPrice"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="patchPrevListing('price')"></p-inputSwitch>
                            </div>
                          </div>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Configuration</p>
                            <div class="SP-switch ml-3">
                              <p-inputSwitch
                                [(ngModel)]="isConfig"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="patchPrevListing('confige')"></p-inputSwitch>
                            </div>
                          </div>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Features</p>
                            <div class="SP-switch ml-3">
                              <p-inputSwitch
                                [(ngModel)]="isFeature"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="patchPrevListing('feature')"></p-inputSwitch>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <p-dialog
                      [showHeader]="true"
                      [(visible)]="copyDialog"
                      [draggable]="false"
                      [style]="{ width: '30vw' }"
                      [modal]="true"
                      [baseZIndex]="100000"
                      [contentStyleClass]="'confirmDeleteViewDialog'">
                      <ng-template pTemplate="header">
                        <p class="f-14 text-white">
                          {{ editProperty.controls['property_address'].value }}
                        </p>
                      </ng-template>
                      <div class="p-modal-body p-project-detail-body prop-action-meta" style="position: inherit">
                        <div class="col-sm-14 text-left my-3">
                          <p class="_fw-600">Would you like to copy this listing?</p>
                        </div>
                        <div class="text-right p-modal-footer">
                          <button (click)="copyDetail('no')" class="_cancel-btn mr-2">No</button>
                          <button (click)="copyDetail('yes')" class="_outline-btn">Yes</button>
                        </div>
                      </div>
                    </p-dialog>
                  </div>
                </div>
                <div class="d-flex align-items-end flex-wrap mt-2" *ngIf="editProperty.controls['property_address'].value">
                  <div class="mr-2 d-flex mb-2 hideAddress">
                    <p-checkbox
                      [formControl]="editProperty.controls['isHideAddress']"
                      [binary]="true"
                      [ngClass]="{
                        '_input-error': editProperty.controls['isHideAddress'].hasError('required') && submitted,
                      }"></p-checkbox>
                    <p style="font-size: 12px !important">Hide Address</p>
                  </div>
                </div>
              </div>
              <div class="lh__chips">
                <span class="lh-chip" *ngIf="editProperty.controls['type']?.value">
                  <span class="lh-chip__key">Type:</span> {{ editProperty.controls['type']?.value }}
                </span>
                <span class="lh-chip" *ngIf="editProperty.controls['property_status']?.value">
                  <span class="lh-chip__key">Status:</span> {{ editProperty.controls['property_status']?.value }}
                </span>
                <span class="lh-chip" *ngIf="editProperty.controls['listing_type']?.value">
                  <span class="lh-chip__key">Type:</span> {{ editProperty.controls['listing_type']?.value }}
                </span>
                <span class="lh-chip" *ngIf="selectedProperty?.id"> <span class="lh-chip__key">Property ID:</span> {{ selectedProperty?.id }} </span>
                <span class="lh-chip" *ngIf="subOfficeName"> <span class="lh-chip__key">Sub Office:</span> {{ subOfficeName }} </span>
              </div>
              <ng-container *ngIf="activeContract?.length > 0">
                <ng-container *ngFor="let contract of activeContract">
                  <div class="mt-2 cursor-pointer">
                    <p
                      (click)="openRightModal(contract, 'edit_contract')"
                      *ngIf="
                        (contract?.contractStatus?.toLowerCase() == 'settled' || contract?.contractStatus?.toLowerCase() == 'settlement') &&
                          contract?.settlement != '' &&
                          contract?.settlement != null;
                        else elseContractStatusPart
                      ">
                      Contract: {{ contract?.contractStatus }} on
                      {{ contract?.settlement | date: 'dd/MM/yyyy' }}
                    </p>
                    <ng-template #elseContractStatusPart>
                      <p (click)="openRightModal(contract, 'edit_contract')">Contract: {{ contract?.contractStatus }}</p>
                    </ng-template>
                  </div>
                </ng-container>
              </ng-container>
              <div class="d-flex mt-2">
                <p
                  class="sold_info"
                  *ngIf="
                    (editProperty.controls['soldDate'].value || editProperty.controls['soldPrice'].value) &&
                    editProperty.controls['property_status'].value == 'Sold'
                  ">
                  <span>Date Sold: {{ editProperty.controls['soldDate'].value | date: 'dd/MM/yyyy' }}</span>
                  <span>Sold Price: ${{ editProperty.controls['soldPrice'].value }}</span>
                  <span>
                    Disclose Price:
                    {{ editProperty.controls['soldPriceDisplay'].value ? 'Yes' : 'No' }}
                  </span>
                </p>
                <div
                  *ngIf="
                    (editProperty.controls['soldDate'].value || editProperty.controls['soldPrice'].value) &&
                    editProperty.controls['property_status'].value == 'Sold'
                  ">
                  <img [src]="common_images?.pencil_icon" class="pencil-cross cursor-pointer ml-3" (click)="soldModalDialog?.show()" />
                </div>
              </div>
            </div>
            <div class="lh__actions">
              <ng-container *ngxPermissionsOnly="['allproperties.manage', 'allproperties.add']">
                <div
                  *ngIf="
                    lmService.listing_show_div == 'add_listing_from_property' ||
                    lmService.listing_show_div == 'add_listing_property' ||
                    lmService.listing_show_div == 'add_listing_property_listing'
                  ">
                  <div class="{{ mobSmallToggle || tabletToggle ? 'd-block' : 'd-flex' }} justify-content-between gap-2">
                    <div>
                      <ng-container
                        *ngIf="
                          userPermission?.includes('listing_tab.view') ||
                          userRole == 'administrators' ||
                          userRole == 'master admin' ||
                          userRole == 'operations manager'
                        ">
                        <button class="preview-btn" (click)="this.getAgentModel()">Preview Listing</button>
                      </ng-container>
                    </div>
                    <div>
                      <button class="_outline-btn btn-sm" (click)="CreateProperty('onlyCreate')" [class.disabled]="submitDisable || isPrivate">
                        Save
                      </button>
                      <button class="_primary-btn btn-sm" (click)="CreateProperty('create')" [class.disabled]="submitDisable || isPrivate">
                        Save & Close
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="AuthUser?.role?.toLowerCase() == 'sales agent' && selectedProperty?.agent == AuthUser?._id; else elseEditPart">
                <div *ngxPermissionsOnly="['allproperties.manage', 'allproperties.add']">
                  <div
                    *ngIf="lmService.listing_show_div == 'edit_listing_property'"
                    class="{{ dynamicPanelSizes[0] <= 35 || mobSmallToggle || tabletToggle ? 'd-block' : 'd-flex' }} justify-content-between gap-2">
                    <div>
                      <ng-container
                        *ngIf="
                          userPermission?.includes('listing_tab.view') ||
                          userRole == 'administrators' ||
                          userRole == 'master admin' ||
                          userRole == 'operations manager'
                        ">
                        <button class="preview-btn" (click)="this.getAgentModel()">Preview Listing</button>
                      </ng-container>
                    </div>
                    <div
                      *ngIf="
                        userRole == 'administrators' ||
                        userRole == 'master admin' ||
                        userRole == 'operations manager' ||
                        selectedProperty?.agent == AuthUser?._id ||
                        selectedProperty?.secondaryagent == AuthUser?._id
                      ">
                      <button
                        type="button"
                        class="_addNew p-2"
                        (click)="toggleListingEdit()"
                        [pTooltip]="isListingReadOnly ? 'Edit' : 'Done editing'"
                        tooltipPosition="bottom">
                        <img [src]="common_images?.edit_icon" class="cursor-pointer" width="16px" />
                      </button>
                      <ng-container *ngIf="!isListingReadOnly">
                        <button class="_outline-btn btn-sm" (click)="updateProperty('onlyUpdate')" [class.disabled]="submitDisable || isPrivate">
                          Save
                        </button>
                        <button class="_primary-btn btn-sm" (click)="updateProperty('update')" [class.disabled]="submitDisable || isPrivate">
                          Save & Close
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #elseEditPart>
                <div *ngxPermissionsOnly="['allproperties.manage', 'allproperties.edit']">
                  <div
                    *ngIf="lmService.listing_show_div == 'edit_listing_property'"
                    class="{{
                      dynamicPanelSizes[0] <= 35 || mobSmallToggle || tabletToggle ? 'd-block' : 'd-flex'
                    }} align-items-center justify-content-between gap-2">
                    <div>
                      <ng-container *ngIf="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager'">
                        <button class="preview-btn" (click)="this.getAgentModel()">Preview Listing</button>
                      </ng-container>
                    </div>
                    <div
                      *ngIf="
                        userRole == 'administrators' ||
                        userRole == 'master admin' ||
                        userRole == 'operations manager' ||
                        selectedProperty?.agent == AuthUser?._id ||
                        selectedProperty?.secondaryagent == AuthUser?._id
                      ">
                      <button
                        type="button"
                        class="_addNew p-2"
                        (click)="toggleListingEdit()"
                        [pTooltip]="isListingReadOnly ? 'Edit' : 'Done editing'"
                        tooltipPosition="bottom">
                        <img [src]="common_images?.edit_icon" class="cursor-pointer" width="16px" />
                      </button>
                      <ng-container *ngIf="!isListingReadOnly">
                        <button class="_outline-btn btn-sm" (click)="updateProperty('onlyUpdate')" [class.disabled]="submitDisable || isPrivate">
                          Save
                        </button>
                        <button class="_primary-btn btn-sm" (click)="updateProperty('update')" [class.disabled]="submitDisable || isPrivate">
                          Save & Close
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </header>

          <!-- Page furniture, not a record view: it fills in as the form does, so it is there
               while a listing is being created too. -->
          <section class="lh-stats">
            <div class="lh-stats__card lh-stats__card--figures">
              <div class="lh-stats__cell lh-stats__cell--price">
                <p class="lh-stats__label">Price</p>
                <!-- A listing can carry only the free-text price ("Offers over …", "Contact agent"),
                     so that stands in when there is no number to show. -->
                <p class="lh-stats__value">
                  <ng-container *ngIf="editProperty.controls['value'].value; else headerDisplayPrice">
                    {{ '$' + (editProperty.controls['value'].value | number) }}
                  </ng-container>
                  <ng-template #headerDisplayPrice>{{ editProperty.controls['display_price'].value || '-' }}</ng-template>
                </p>
              </div>
              <div class="lh-stats__cell lh-stats__counts">
                <span class="lh-count">
                  <img [src]="common_images?.bed_icon" alt="Bedrooms" />
                  {{ editProperty.controls['beds'].value || 0 }}
                </span>
                <span class="lh-count">
                  <img [src]="common_images?.bath_icon" alt="Bathrooms" />
                  {{ editProperty.controls['baths'].value || 0 }}
                </span>
                <span class="lh-count">
                  <img [src]="common_images?.car_icon" alt="Car spaces" />
                  {{ carSpaceTotal }}
                </span>
              </div>
            </div>
            <div class="lh-stats__card lh-stats__card--agents">
              <div class="lh-stats__cell">
                <p class="lh-stats__label">Agent</p>
                <div class="lh-agents">
                  <span class="lh-agent" *ngFor="let name of headerAgents">
                    <span class="lh-agent__avatar">{{ name.charAt(0) | uppercase }}</span>
                    {{ name }}
                  </span>
                </div>
              </div>
            </div>
            <div class="lh-stats__card lh-stats__card--project">
              <div class="lh-stats__cell lh-stats__cell--project">
                <div class="lh-stats__project">
                  <p class="lh-stats__label">Project</p>
                  <!-- Any listing can belong to a project. A Residential one always belongs to the
                       residential lot project, so its project is filled in and locked; every other
                       type picks its own. -->
                  <ng-select
                    *ngIf="!isListingReadOnly; else headerProjectName"
                    class="_select"
                    formControlName="related_to_project"
                    [items]="listingProjects"
                    [readonly]="isPrivate || isResidentialType"
                    bindLabel="Project_Name"
                    bindValue="_id"
                    [searchable]="true"
                    [clearable]="!isResidentialType"
                    placeholder="Select Project"
                    (change)="onListingProjectChange()">
                  </ng-select>
                  <ng-template #headerProjectName>
                    <p class="lh-stats__value">{{ headerProjectLabel }}</p>
                  </ng-template>
                </div>
                <img class="lh-stats__project-icon" [src]="images?.building_icon" alt="" />
              </div>
              <div class="lh-stats__cell" *ngIf="isResidentialLotProject && residentialLots?.length">
                <div class="lh-stats__project">
                  <p class="lh-stats__label">Residential Project Lot</p>
                  <ng-select
                    *ngIf="!isListingReadOnly; else headerLotName"
                    class="_select"
                    formControlName="residential_project_lot"
                    [items]="residentialLots"
                    [readonly]="isPrivate"
                    bindLabel="lot_name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Select Lot"
                    (change)="syncResidentialLotProject()">
                  </ng-select>
                  <ng-template #headerLotName>
                    <p class="lh-stats__value">{{ residentialLotName || '-' }}</p>
                  </ng-template>
                </div>
              </div>
            </div>
          </section>
          <div>
            <ng-container *ngIf="imgNotFoundList?.length > 0">
              <p class="text-danger cursor-pointer" (click)="imagesUploadErrorMessage = !imagesUploadErrorMessage">
                {{
                  imgNotFoundList?.length > 1
                    ? imgNotFoundList?.length + ' Images'
                    : imgNotFoundList?.length +
                      '
                Image'
                }}
                not found
              </p>
              <div class="error-message" [ngClass]="{ 'd-none': imagesUploadErrorMessage }">
                <ul>
                  <li class="pb-1 cursor-pointer" *ngFor="let img of imgNotFoundList">
                    {{ img | capitalizephrase }}
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="menuIcon">
          <div class="menuIconTabs">
            <div class="show-current-tab {{ mobToggle && activeIndex == 20 ? 'mb-4' : '' }}" (click)="showMenu = !showMenu">
              <div class="d-flex align-items-center">
                <img src="{{ selectedItem?.img }}" alt="gavel" class="mr-1 mb-1 img-active" width="18px" height="18px" *ngIf="selectedItem?.img" />
                <i class="{{ selectedItem?.icon }} f-14 mr-2" *ngIf="selectedItem?.icon" style="color: #229276"></i>
                <p style="color: #229276">{{ selectedItem?.name }}</p>
              </div>
              <div>
                <i class="pi pi-angle-down cursor-pointer iconic-style" *ngIf="!showMenu"></i>
                <i class="pi pi-angle-up cursor-pointer iconic-style" *ngIf="showMenu"></i>
              </div>
            </div>
          </div>
          <div class="">
            <ul class="unOrderListMenu" *ngIf="showMenu">
              <li
                class="listMenu d-flex align-items-center"
                *ngFor="let item of items; let i = index"
                [ngClass]="{ activeList: selectedIndex === i }"
                (click)="selectItem(item); selectedIndex = i">
                <ng-container *ngIf="item?.img; else icon">
                  <img src="{{ item?.img }}" alt="img" width="18px" class="mr-2" *ngIf="item?.img" />
                </ng-container>
                <ng-template #icon>
                  <i class="{{ item?.icon }} f-14 mr-2" *ngIf="item?.icon"></i>
                </ng-template>
                <a [ngClass]="{ activeIndexText: selectedIndex === i }" class="activeIndex"> {{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- site-card -->
        <div class="{{ mobToggle && activeIndex == 20 ? '' : 'listing-Details' }} mb-1">
          <div class="pb-2 pt-2" *ngIf="numOfNotValidFields > 0">
            <p class="form-error font-weight-bold cursor-pointer" (click)="notDisplayRequiredMessage = false">
              You have {{ numOfNotValidFields }} notifications. Select to view.
            </p>
            <div class="error-message" [ngClass]="{ 'd-none': notDisplayRequiredMessage }">
              <ul>
                <li class="pb-1 cursor-pointer" *ngFor="let message of requiredErrorMessages" (click)="ActivateTabIndexByError(message.field)">
                  {{ message?.message | capitalizephrase }}
                </li>
              </ul>
            </div>
          </div>
          <div class="align-items-center primary-tabs b-b-tabs">
            <ul class="nav nav-pills mb-0 tools-tab-nav listing-tab-nav w-100 align-items-end" id="pills-tab" role="tablist">
              <ng-container *ngTemplateOutlet="listingDetailTabs"></ng-container>
              <ng-container *ngTemplateOutlet="listingWorkTabs"></ng-container>
            </ul>
          </div>
          <div class="tab-content" id="pills-tabContent">
            <!-- Everything here comes from GET /listing-dashboard/:id, read when the tab is opened. -->
            <div
              id="dashboard"
              role="tabpanel"
              aria-labelledby="pills-dashboard-tab"
              tabindex="0"
              class="tab-pane fade {{ activeIndex === 5 && 'show active' }}">
              <ng-container *ngIf="property_id || insertedPropertyId; else listingNotDashboard">
                <div class="ld-card ldash-state" *ngIf="dashboardLoading">
                  <i class="pi pi-spin pi-spinner mr-2"></i>
                  Loading this listing's dashboard…
                </div>

                <div class="ld-card ldash-state" *ngIf="!dashboardLoading && dashboardError">
                  <i class="pi pi-exclamation-triangle mr-2 text-danger"></i>
                  {{ dashboardError }}
                  <button class="_outline-btn ml-3" (click)="loadListingDashboard(true)">Try again</button>
                </div>

                <div class="ldash" *ngIf="!dashboardLoading && !dashboardError && listingDashboard">
                  <div class="ldash-band">
                    <!-- Actions Today — the AI brief, then the checklist the endpoint builds from the
                         same figures the panels below show. -->
                    <section class="ldash-card ldash-card--actions" *ngIf="listingDashboard?.actions_today">
                      <header class="ldash-head is-clickable" (click)="openWorkTab(4)">
                        <span class="ldash-head__icon"><i class="pi pi-sparkles"></i></span>
                        <p class="ldash-head__title">Actions Today</p>
                        <i class="pi pi-angle-right ldash-head__more"></i>
                      </header>

                      <p class="ldash-summary" *ngIf="listingDashboard?.actions_today?.summary">
                        {{ listingDashboard?.actions_today?.summary }}
                      </p>

                      <ul class="ldash-actions">
                        <li class="ldash-action" *ngFor="let item of listingDashboard?.actions_today?.items" [class.is-done]="item?.done">
                          <i class="pi" [ngClass]="item?.done ? 'pi-check-circle' : 'pi-circle'"></i>
                          <span>{{ item?.label }}</span>
                        </li>
                      </ul>
                    </section>

                    <!-- Images -->
                    <section class="ldash-card" *ngIf="listingDashboard?.images">
                      <header class="ldash-head is-clickable" (click)="openListingTab(1); isImg = true; isDocuments = false">
                        <span class="ldash-head__icon"><i class="pi pi-images"></i></span>
                        <p class="ldash-head__title">Images</p>
                        <i class="pi pi-angle-right ldash-head__more"></i>
                      </header>
                      <ng-container *ngIf="!hasNoImages; else imagesBlank">
                        <p class="ldash-count">
                          {{ listingDashboard?.images?.total }} {{ listingDashboard?.images?.total === 1 ? 'image' : 'images' }}
                        </p>
                        <div class="ldash-images">
                          <img
                            class="ldash-images__tile"
                            *ngFor="let image of listingDashboard?.images?.items"
                            [src]="dashboardImageUrl(image)"
                            [alt]="image?.name"
                            (click)="openListingTab(1); isImg = true; isDocuments = false" />
                        </div>
                        <a class="ldash-foot-link" href="javascript:void(0)" (click)="openListingTab(1); isImg = true; isDocuments = false">
                          View all images <i class="pi pi-external-link f-10 ml-1"></i>
                        </a>
                      </ng-container>
                      <ng-template #imagesBlank>
                        <div class="ldash-blank">
                          <span class="ldash-blank__icon"><i class="pi pi-images"></i></span>
                          <p class="ldash-blank__title">No images yet</p>
                          <p class="ldash-blank__note">Photos uploaded to this listing will appear here.</p>
                          <button class="_outline-btn" (click)="openListingTab(1); isImg = true; isDocuments = false">Add Images</button>
                        </div>
                      </ng-template>
                    </section>

                    <!-- Leads. The period dropdown re-reads this panel on its own. -->
                    <section class="ldash-card" *ngIf="listingDashboard?.leads">
                      <header class="ldash-head">
                        <span class="ldash-head__icon"><i class="pi pi-users"></i></span>
                        <p class="ldash-head__title">Leads</p>
                        <ng-select
                          class="_select ldash-period"
                          [items]="dashboardLeadPeriods"
                          [(ngModel)]="dashboardLeadPeriod"
                          [ngModelOptions]="{ standalone: true }"
                          bindLabel="label"
                          bindValue="key"
                          [searchable]="false"
                          [clearable]="false"
                          (change)="onDashboardLeadPeriodChange()">
                        </ng-select>
                      </header>
                      <div class="ldash-rows ldash-rows--banded" [class.is-loading]="dashboardLeadsLoading">
                        <div class="ldash-row" *ngFor="let tile of dashboardLeadMetrics">
                          <span>{{ tile?.label }}</span>
                          <span class="ldash-row__value">{{ tile?.metric ? (tile?.metric?.value ?? 0) : '–' }}</span>
                        </div>
                      </div>
                    </section>

                    <!-- Live Portals -->
                    <section class="ldash-card" *ngIf="listingDashboard?.portals">
                      <header class="ldash-head is-clickable" (click)="openListingTab(6); getDomainEmail()">
                        <span class="ldash-head__icon"><i class="pi pi-globe"></i></span>
                        <p class="ldash-head__title">Live Portals</p>
                        <i class="pi pi-angle-right ldash-head__more"></i>
                      </header>
                      <ng-container *ngIf="!hasNoPortalRows; else portalsBlank">
                        <div class="ldash-portals">
                          <div class="ldash-portal" *ngFor="let portal of dashboardPortals">
                            <span class="ldash-portal__badge" [ngClass]="'is-' + portal?.key">{{ portal?.name?.charAt(0) | uppercase }}</span>
                            <p class="ldash-portal__name">{{ portal?.name }}</p>
                            <span class="ldash-status" [ngClass]="'is-' + portal?.status">{{
                              portal?.status === 'off' ? 'Off' : portal?.status
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #portalsBlank>
                        <div class="ldash-blank">
                          <span class="ldash-blank__icon"><i class="pi pi-globe"></i></span>
                          <p class="ldash-blank__title">No portals enabled</p>
                          <p class="ldash-blank__note">Once this listing is published, connected portals will appear here.</p>
                          <button class="_outline-btn" (click)="openListingTab(6); getDomainEmail()">Manage Portals</button>
                        </div>
                      </ng-template>
                    </section>
                  </div>

                  <div class="ldash-band">
                    <!-- Inspections -->
                    <section class="ldash-card ldash-card--inspections" *ngIf="listingDashboard?.inspections">
                      <header class="ldash-head">
                        <span class="ldash-head__icon"><i class="pi pi-calendar"></i></span>
                        <p class="ldash-head__title">Inspections</p>
                        <span class="ldash-chip">Upcoming</span>
                      </header>

                      <ng-container *ngIf="listingDashboard?.inspections?.upcoming?.length; else inspectionsBlank">
                        <!-- `date` is a plain calendar day and the times are display strings, so they
                             are shown as they came rather than put through a timezone again. -->
                        <div class="ldash-dates">
                          <div class="ldash-date" *ngFor="let inspection of listingDashboard?.inspections?.upcoming" (click)="openListingTab(2)">
                            <span class="ldash-date__badge">
                              <b>{{ inspection?.date | date: 'd' }}</b>
                              {{ inspection?.date | date: 'MMM' }}
                            </span>
                            <div class="ldash-date__detail">
                              <p class="ldash-date__day">{{ inspection?.date | date: 'EEEE' }}</p>
                              <p class="ldash-date__time">{{ inspection?.start_time }} – {{ inspection?.end_time }}</p>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #inspectionsBlank>
                        <div class="ldash-blank">
                          <span class="ldash-blank__icon"><i class="pi pi-calendar"></i></span>
                          <p class="ldash-blank__title">No future inspections scheduled</p>
                        </div>
                      </ng-template>

                      <div class="ldash-inspection-foot">
                        <div class="ldash-row ldash-row--plain" *ngIf="listingDashboard?.inspections?.last_ofi">
                          <span>Last OFI</span>
                          <span class="ldash-row__value">{{ listingDashboard?.inspections?.last_ofi | date: 'EEE d MMM y, h:mm a' }}</span>
                        </div>
                        <a class="ldash-foot-link" href="javascript:void(0)" (click)="openListingTab(2)">
                          View all inspections <i class="pi pi-external-link f-10 ml-1"></i>
                        </a>
                      </div>
                    </section>

                    <!-- One card, two headed columns: the people on the deal beside the contract's own
                         dates. Only the contract side is a way through to the Legal tab. -->
                    <section class="ldash-card ldash-card--contract" *ngIf="listingDashboard?.contract">
                      <div class="ldash-split">
                        <div class="ldash-split__col">
                          <header class="ldash-head">
                            <span class="ldash-head__icon"><i class="pi pi-id-card"></i></span>
                            <p class="ldash-head__title">Contacts</p>
                          </header>
                          <div class="ldash-rows">
                            <div class="ldash-row" *ngFor="let row of dashboardContacts">
                              <span>{{ row?.label }}</span>
                              <span class="ldash-row__value">{{ row?.value }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="ldash-split__col">
                          <header class="ldash-head is-clickable" (click)="openListingTab(3); solicitorContact(); getContractAccordingProperty()">
                            <span class="ldash-head__icon"><i class="pi pi-calendar"></i></span>
                            <p class="ldash-head__title">Contracts &amp; Critical Dates</p>
                            <i class="pi pi-angle-right ldash-head__more"></i>
                          </header>
                          <div class="ldash-rows">
                            <div class="ldash-row" *ngFor="let row of dashboardCriticalDates">
                              <span>{{ row?.label }}</span>
                              <span class="ldash-row__value">{{ row?.value }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </ng-container>
              <ng-template #listingNotDashboard>
                <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
              </ng-template>
            </div>
            <div
              id="listDetails"
              role="tabpanel"
              aria-labelledby="pills-listDetails-tab"
              tabindex="0"
              class="tab-pane fade {{ activeIndex === 0 && 'show active' }}"
              [class.ld-view]="isListingReadOnly">
              <div class="ld-grid">
                <section class="ld-card">
                  <div class="ld-card__head">
                    <p class="ld-card__title"><i class="ld-card__icon pi pi-home"></i>Listing Information</p>
                  </div>
                  <div class="ld-row ld-row--2">
                    <div class="ld-field">
                      <p class="ld-field__label">Property Type</p>
                      <ng-select
                        class="primary-tag _select"
                        formControlName="type"
                        [items]="listingService.listingPropertyOption.property_Types"
                        [readonly]="isPrivate"
                        bindLabel="tag_name"
                        bindValue="tag_name"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Property Type"
                        (change)="onPropertyTypeChange(); applyDomainLandTypeDefault()"
                        [ngClass]="{
                          '_input-error': editProperty.controls['type'].hasError('required') && submitted,
                        }">
                      </ng-select>
                    </div>
                    <div class="ld-field" *ngIf="isLandType">
                      <p class="ld-field__label">Domain Land Type</p>
                      <ng-select
                        class="_select"
                        formControlName="domain_land_type"
                        [items]="domainLandTypes"
                        [readonly]="isPrivate"
                        bindLabel="label"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        placeholder="Domain Land Type">
                      </ng-select>
                    </div>
                    <div class="ld-field">
                      <p class="ld-field__label">Listings Status</p>
                      <ng-container *ngIf="editProperty.controls['listing_type'].value === 'Rental'; else no_rental">
                        <ng-select
                          class="danger-tag _select"
                          formControlName="property_status"
                          [items]="listingService.listingPropertyOption.property_Status_rental"
                          [readonly]="isPrivate"
                          bindLabel="tag_name"
                          bindValue="tag_name"
                          [searchable]="true"
                          [clearable]="false"
                          placeholder="Listing Status"
                          (change)="propertyStatus($event); soldStatus($event)"
                          [ngClass]="{
                            '_input-error': editProperty.controls['property_status'].hasError('required') && submitted,
                          }">
                        </ng-select>
                      </ng-container>
                      <ng-template #no_rental>
                        <ng-select
                          class="danger-tag _select"
                          formControlName="property_status"
                          [items]="listingService.listingPropertyOption.property_Status_no_rental"
                          [readonly]="isPrivate"
                          bindLabel="tag_name"
                          bindValue="tag_name"
                          [searchable]="true"
                          [clearable]="false"
                          placeholder="Listing Status"
                          (change)="propertyStatus($event); soldStatus($event)"
                          [ngClass]="{
                            '_input-error': editProperty.controls['property_status'].hasError('required') && submitted,
                          }">
                        </ng-select>
                      </ng-template>
                    </div>
                    <div class="ld-field">
                      <p class="ld-field__label">Listing Type</p>
                      <ng-select
                        class="active-tag _select"
                        formControlName="listing_type"
                        [items]="listingService.listingPropertyOption.listing_Type"
                        [readonly]="isPrivate"
                        bindLabel="tag_name"
                        bindValue="tag_name"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Listings Type"
                        [ngClass]="{
                          '_input-error': editProperty.controls['listing_type'].hasError('required') && submitted,
                        }">
                      </ng-select>
                    </div>
                    <!-- The header carries the sub office as a chip, so the picker is only here to change it. -->
                    <div class="ld-field" *ngIf="!isListingReadOnly">
                      <p class="ld-field__label">Sub Office</p>
                      <ng-select
                        [items]="subOfficeList"
                        formControlName="sub_office_id"
                        name="office_name"
                        bindLabel="office_name"
                        bindValue="_id"
                        [searchable]="true"
                        [clearable]="true"
                        placeholder="Select">
                      </ng-select>
                    </div>
                  </div>
                </section>

                <section class="ld-card">
                  <div class="ld-card__head">
                    <p class="ld-card__title"><i class="ld-card__icon pi pi-dollar"></i>Pricing Information</p>
                  </div>
                  <ng-container *ngIf="editProperty.controls['listing_type'].value === 'Auction'">
                    <div class="ld-field">
                      <p class="ld-field__label">Auction date</p>
                      <p-calendar
                        dateFormat="dd/mm/yy"
                        [firstDayOfWeek]="1"
                        class="_input"
                        formControlName="date"
                        [ngClass]="{
                          '_input-error': editProperty.controls['date'].hasError('required') && submitted,
                        }"
                        [readonlyInput]="true">
                      </p-calendar>
                    </div>
                    <div class="ld-field">
                      <p class="ld-field__label">Auction Start time</p>
                      <div class="ld-row ld-row--3">
                        <ng-select
                          [(ngModel)]="selectedAuctionStartHour"
                          [items]="hours"
                          placeholder="Hr"
                          (change)="auctionStartHourChange()"
                          [ngModelOptions]="{ standalone: true }"
                          class="_select">
                        </ng-select>
                        <ng-select
                          [(ngModel)]="selectedAuctionStartMinutes"
                          [items]="minutes"
                          placeholder="Min"
                          (change)="auctionStartMinuteChange()"
                          [ngModelOptions]="{ standalone: true }"
                          class="_select">
                        </ng-select>
                        <ng-select
                          [(ngModel)]="selectedAuctionStartDuration"
                          [items]="duration"
                          placeholder="Min"
                          (change)="auctionStartHourChange()"
                          [ngModelOptions]="{ standalone: true }"
                          [clearable]="false"
                          class="_select">
                        </ng-select>
                      </div>
                    </div>
                  </ng-container>
                  <div class="ld-row">
                    <div class="ld-field" *ngIf="!otherLabel">
                      <div class="d-flex align-items-center">
                        <p class="ld-field__label mb-0">
                          <span *ngIf="otherLabel" class="mr-1">Rental</span>
                          <span *ngIf="forLease">Price</span>
                        </p>
                        <i
                          class="pi pi-info-circle f-12 cursor-pointer ml-2"
                          tooltipPosition="right"
                          pTooltip="Price is used to determine the listing's relevance in search results"></i>
                      </div>
                      <div class="position-relative">
                        <app-price-input
                          [field_value]="editProperty.controls['value'].value"
                          [isRequire]="editProperty.controls['value'].hasError('required') && submitted ? true : false"
                          (onUpdate)="updatePrice($event, 'value')">
                        </app-price-input>
                      </div>
                    </div>
                    <div class="ld-field" *ngIf="forLease">
                      <div class="d-flex align-items-center">
                        <p class="ld-field__label mb-0">Display Price</p>
                        <i
                          class="pi pi-info-circle f-12 cursor-pointer ml-2"
                          tooltipPosition="right"
                          pTooltip="The text entered here will be displayed on the listing"></i>
                      </div>
                      <input
                        type="text"
                        class="_input"
                        formControlName="display_price"
                        style="text-indent: 5px"
                        [ngClass]="{
                          '_input-error': editProperty.controls['display_price'].hasError('required') && submitted,
                        }"
                        (keyup)="checkCharacterLimit()"
                        [maxlength]="50" />
                      <span class="dummy-text" *ngIf="editProperty.controls['display_price'].value?.length >= 50">
                        <p class="form-error">Text character limit of 50.<br /></p>
                      </span>
                    </div>
                  </div>
                  <ng-container *ngIf="otherLabel">
                    <div class="ld-row">
                      <div class="ld-field">
                        <p class="ld-field__label">Rental per week</p>
                        <div class="position-relative">
                          <app-price-input
                            [field_value]="editProperty.controls['rentalPerWeek'].value"
                            [isRequire]="editProperty.controls['rentalPerWeek'].hasError('required') && submitted ? true : false"
                            (onUpdate)="updatePrice($event, 'rentalPerWeek')">
                          </app-price-input>
                        </div>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Price Display</p>
                        <input
                          type="text"
                          class="_input"
                          formControlName="display_price"
                          style="text-indent: 5px"
                          (keyup)="checkCharacterLimitForLease()"
                          [ngClass]="{
                            '_input-error': editProperty.controls['display_price'].hasError('required') && submitted,
                          }"
                          [maxlength]="50" />
                        <span class="dummy-text" *ngIf="editProperty.controls['display_price'].value?.length >= 50">
                          <p class="form-error">Text character limit of 50.<br /></p>
                        </span>
                      </div>
                    </div>
                    <div class="ld-row">
                      <div class="ld-field">
                        <p class="ld-field__label">Security Bond</p>
                        <div class="position-relative">
                          <app-price-input
                            [field_value]="editProperty.controls['securityBond'].value"
                            [isRequire]="editProperty.controls['securityBond'].hasError('required') && submitted ? true : false"
                            (onUpdate)="updatePrice($event, 'securityBond')">
                          </app-price-input>
                        </div>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Available Date</p>
                        <p-calendar
                          dateFormat="dd/mm/yy"
                          class="_input"
                          formControlName="availableDate"
                          [ngClass]="{
                            '_input-error': editProperty.controls['availableDate'].hasError('required') && submitted,
                          }"
                          [readonlyInput]="true">
                        </p-calendar>
                      </div>
                    </div>
                  </ng-container>
                </section>

                <section class="ld-card">
                  <div class="ld-card__head">
                    <p class="ld-card__title"><i class="ld-card__icon pi pi-users"></i>Listing Agents</p>
                    <button class="add-plus-btn" (click)="addOtherAgent()" name="other_agents">
                      <i class="pi pi-plus f-16" title="Add Agent"></i>
                    </button>
                  </div>
                  <div class="ld-row">
                    <div class="ld-field">
                      <p class="ld-field__label">Primary Agent</p>
                      <ng-select
                        formControlName="agent"
                        [items]="originalAssigns"
                        [searchable]="true"
                        bindLabel="full_name"
                        bindValue="_id"
                        placeholder="Select Agent"
                        class="_select"
                        (clear)="onRemoveAgent()"
                        [ngClass]="{
                          '_input-error': editProperty.controls['agent'].hasError('required') && submitted,
                        }">
                        <ng-template ng-option-tmp let-item="item">
                          <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                          <p>{{ item.full_name }}</p>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div class="ld-field {{ other_agent?.length ? '' : 'mb-0' }}">
                      <p class="ld-field__label">Secondary Agent</p>
                      <ng-select
                        formControlName="secondaryagent"
                        [items]="originalAssigns"
                        [searchable]="true"
                        bindLabel="full_name"
                        bindValue="_id"
                        placeholder="Select Agent"
                        class="_select"
                        (clear)="onRemoveAgent()"
                        [ngClass]="{
                          '_input-error': editProperty.controls['secondaryagent'].hasError('required') && submitted,
                        }">
                        <ng-template ng-option-tmp let-item="item">
                          <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                          <p>{{ item.full_name }}</p>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="ld-row ld-row--2" *ngIf="other_agent?.length">
                    <div class="ld-field" *ngFor="let otherAgent of other_agent; let i = index">
                      <p class="ld-field__label d-flex align-items-center justify-content-between">
                        <span>Agent {{ i + 3 }}</span>
                        <i class="cursor-pointer pi pi-times-circle" (click)="removeAgent(i)"></i>
                      </p>
                      <ng-select
                        id="otherAgent{{ i }}"
                        [(ngModel)]="otherAgent.other_agents"
                        [ngModelOptions]="{ standalone: true }"
                        [items]="originalAssigns"
                        [searchable]="true"
                        bindLabel="full_name"
                        bindValue="_id"
                        placeholder="Select Agent"
                        class="_select"
                        [ngClass]="{
                          '_input-error': editProperty.controls['other_agents'].hasError('required') && submitted,
                        }">
                        <ng-template ng-option-tmp let-item="item">
                          <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                          <p>{{ item.full_name }}</p>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </section>
              </div>

              <div class="ld-wide-row">
                <section class="ld-card">
                  <div class="ld-card__head">
                    <p class="ld-card__title"><i class="ld-card__icon pi pi-info-circle"></i>Basic Information</p>
                  </div>
                  <div class="ld-row ld-row--3">
                    <div class="ld-field">
                      <p class="ld-field__label">Bedrooms</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="beds"
                        (input)="validateInput($event, 'beds')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['beds'].hasError('min') && submitted,
                        }" />
                    </div>
                    <div class="ld-field">
                      <p class="ld-field__label">Bathrooms</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="baths"
                        (input)="validateInput($event, 'baths')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['baths'].hasError('required') && submitted,
                        }" />
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Ensuite</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="ensuite"
                        (input)="validateInput($event, 'ensuite')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['ensuite'].hasError('required') && submitted,
                        }" />
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Living Areas</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="living_areas"
                        (input)="validateInput($event, 'living_areas')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['living_areas'].hasError('required') && submitted,
                        }" />
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Study</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="study"
                        (input)="validateInput($event, 'study')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['study'].hasError('required') && submitted,
                        }" />
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Pool</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="pools"
                        (input)="validateInput($event, 'pools')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['pools'].hasError('required') && submitted,
                        }" />
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Garage</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="garage"
                        (input)="validateInput($event, 'garage')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['garage'].hasError('required') && submitted,
                        }" />
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Carport</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="car_port"
                        (input)="validateInput($event, 'car_port')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['car_port'].hasError('required') && submitted,
                        }" />
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Open Spaces</p>
                      <input
                        type="number"
                        min="0"
                        class="_input"
                        formControlName="open_spaces"
                        (input)="validateInput($event, 'open_spaces')"
                        [ngClass]="{
                          '_input-error': editProperty.controls['open_spaces'].hasError('required') && submitted,
                        }" />
                    </div>
                  </div>
                  <ng-container
                    *ngIf="
                      editProperty.controls['beds'].value?.toString()?.includes('.') ||
                      editProperty.controls['baths'].value?.toString()?.includes('.')
                    ">
                    <p class="form-error f-8 mt-0">Domain does not allow decimals. The number will be rounded down.</p>
                  </ng-container>
                  <div class="ld-row ld-row--2 mt-2">
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">Land Size</p>
                      <div class="d-flex">
                        <div class="w-50">
                          <input
                            type="number"
                            min="0"
                            (keypress)="allowOnlyNumberAndDecimal($event)"
                            class="_input h-37"
                            formControlName="land_area"
                            [ngClass]="{
                              '_input-error': editProperty.controls['land_area'].hasError('required') && submitted,
                            }" />
                        </div>
                        <div class="w-50 ml-2">
                          <ng-select
                            formControlName="land_area_type"
                            [items]="listingService.listingPropertyOption.land_building_area_type"
                            bindLabel="tag_name"
                            bindValue="tag_name"
                            [searchable]="true"
                            [clearable]="false"
                            class="_select"
                            [ngClass]="{
                              '_input-error': editProperty.controls['land_area_type'].hasError('required') && submitted,
                            }">
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="ld-field mb-0">
                      <p class="ld-field__label">
                        {{ editProperty.controls['type'].value === 'Apartment' ? 'Building Size' : 'House Size' }}
                      </p>
                      <div class="d-flex">
                        <div class="w-50">
                          <input
                            type="number"
                            min="0"
                            (keypress)="allowOnlyNumberAndDecimal($event)"
                            class="_input h-37"
                            formControlName="building_area"
                            [ngClass]="{
                              '_input-error': editProperty.controls['building_area'].hasError('required') && submitted,
                            }" />
                        </div>
                        <div class="w-50 ml-2">
                          <ng-select
                            formControlName="building_area_type"
                            [items]="listingService.listingPropertyOption.land_building_area_type"
                            bindLabel="tag_name"
                            bindValue="tag_name"
                            [searchable]="true"
                            [clearable]="false"
                            class="_select"
                            [ngClass]="{
                              '_input-error': editProperty.controls['building_area_type'].hasError('required') && submitted,
                            }">
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="otherLabel">
                    <div class="ld-row ld-row--2 mt-2">
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">Furnished</p>
                        <p-checkbox
                          formControlName="furnished"
                          [binary]="true"
                          [ngClass]="{
                            '_input-error': editProperty.controls['furnished'].hasError('required') && submitted,
                          }"></p-checkbox>
                      </div>
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">Pet Friendly</p>
                        <p-checkbox
                          formControlName="petFriendly"
                          [binary]="true"
                          [ngClass]="{
                            '_input-error': editProperty.controls['petFriendly'].hasError('required') && submitted,
                          }"></p-checkbox>
                        <span class="dummy-text" *ngIf="editProperty.controls['petFriendly'].hasError('required')">
                          <p class="form-error">Pet Friendly is required<br /></p>
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </section>

                <section class="ld-card">
                  <div class="ld-card__head">
                    <p class="ld-card__title"><i class="ld-card__icon pi pi-star"></i>Features</p>
                  </div>
                  <div class="ld-field {{ forLease ? '' : 'mb-0' }}">
                    <p class="ld-field__label">Features</p>
                    <div class="feature-multi-select">
                      <re-multiSelect
                        [options]="listingService.listingPropertyOption?.property_features"
                        formControlName="features"
                        optionLabel="feature_name"
                        optionValue="feature_name"
                        placeholder="Please Select">
                      </re-multiSelect>
                    </div>
                  </div>
                  <ng-container *ngIf="forLease">
                    <p class="ld-card__subtitle">Other</p>
                    <div class="ld-row">
                      <div class="ld-field">
                        <p class="ld-field__label">Exterior</p>
                        <input
                          type="text"
                          class="_input"
                          [ngClass]="{
                            '_input-error': editProperty.controls['exterior'].hasError('required') && submitted,
                          }"
                          [resetFilterOnHide]="true"
                          formControlName="exterior" />
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Roofing</p>
                        <input
                          type="text"
                          class="_input"
                          [ngClass]="{
                            '_input-error': editProperty.controls['roofing'].hasError('required') && submitted,
                          }"
                          formControlName="roofing" />
                      </div>
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">Energy Rating</p>
                        <input
                          type="text"
                          [ngClass]="{
                            '_input-error': editProperty.controls['energy_rating'].hasError('required') && submitted,
                          }"
                          class="_input"
                          formControlName="energy_rating" />
                      </div>
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">Views</p>
                        <input
                          type="text"
                          [ngClass]="{
                            '_input-error': editProperty.controls['views'].hasError('required') && submitted,
                          }"
                          class="_input"
                          formControlName="views" />
                      </div>
                    </div>
                  </ng-container>
                </section>
              </div>

              <div class="ld-full-row">
                <section class="ld-card">
                  <div class="ld-card__head">
                    <p class="ld-card__title"><i class="ld-card__icon pi pi-file"></i>Description</p>
                  </div>
                  <div class="ld-field">
                    <p class="ld-field__label">Headline</p>
                    <input
                      type="text"
                      class="_input"
                      formControlName="heading"
                      [ngClass]="{
                        '_input-error': editProperty.controls['heading'].hasError('required') && submitted,
                      }" />
                  </div>
                  <div class="ld-field mb-0">
                    <p class="ld-field__label">Description</p>
                    <div class="_paragraph {{ mobToggle ? 'mob-area' : '' }}">
                      <ckeditor
                        formControlName="description_garax"
                        [editor]="Editor"
                        (ready)="onReadyDes($event)"
                        [ngClass]="{
                          '_input-error': editProperty.controls['isHideAddress'].hasError('required') && submitted,
                        }">
                      </ckeditor>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div
              id="img"
              role="tabpanel"
              aria-labelledby="pills-img-tab"
              tabindex="0"
              class="tab-pane listing-pane fade {{ activeIndex === 1 && 'show active' }}">
              <div class="ld-card__head">
                <div>
                  <p class="ld-card__title"><i class="ld-card__icon pi pi-images"></i>Images</p>
                  <p class="ld-card__note">Photos, floorplans and video links for this listing.</p>
                </div>
              </div>
              <ng-container *ngIf="property_id || insertedPropertyId; else listingNotImg">
                <ng-container *ngIf="isImg">
                  <div class="sticky-sidebar">
                    <div class="site-card p-0 row lib-content px-3 library cs-br-16">
                      <app-library-view-mode
                        class="listing-details"
                        (videoLinks)="getLinks($event)"
                        [videoTourLinks]="receiveLinks"
                        [hidePropertyLibrary]="true"
                        [librarydata]="libraryDataEmitter"
                        [tooltipText]="'Only JPEG is allowed for images, and PDFs for floorplans.'"
                        *ngIf="lmService.listing_show_div == 'edit_listing_property' || insertedPropertyId?.length > 0 || property_id"
                        category="useroffice"
                        [propertyId]="property_id || insertedPropertyId"
                        defaultopen="images"
                        [isBackBtnShown]="true"
                        [isBackBtnIndex]="1"
                        innerdefault="property images"
                        (LibraryOutputData)="GetLibraryData($event)"
                        (imageUploadedError)="imagesUploadError($event)">
                      </app-library-view-mode>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #listingNotImg>
                <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
              </ng-template>
            </div>
            <div
              id="inspection"
              role="tabpanel"
              aria-labelledby="pills-inspection-tab"
              tabindex="0"
              class="tab-pane narrow-pane fade {{ activeIndex === 2 && 'show active' }}">
              <ng-container *ngIf="property_id || insertedPropertyId; else listingNotInspection">
                <ng-container *ngIf="selectedProperty?.agent; else noAgent">
                  <ng-container *ngIf="!emailConnected && isSalesAgent == true && isPropertyAgent == true">
                    <div class="ld-card mb-3">
                      <div class="d-flex align-items-center flex-wrap">
                        <img [src]="images?.properties_icon" class="mr-4 email-connect" />
                        <div>
                          <p class="mb-3 l-h-1-31 f-12">
                            Connect your email to Remmi. You can synchronise messages and link them to your leads and contacts.
                          </p>
                          <button *ngIf="!emailConnected && !showConnectBtns" class="_outline-btn" (click)="showConnectBtns = true">
                            Connect Your Account
                          </button>
                          <ng-container *ngIf="!emailConnected && showConnectBtns">
                            <div class="d-flex align-items-center">
                              <a href="javascript:void(0)" (click)="gsuiteLogin()" class="_outline-btn mr-2">G Suite</a>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <div class="ld-card mb-3">
                    <div class="ld-card__head">
                      <p class="ld-card__title">
                        <i class="ld-card__icon pi pi-calendar-plus"></i>
                        {{ editingInspection ? 'Edit Inspection' : 'Add Inspection' }}
                      </p>
                      <button
                        type="button"
                        class="insp-collapse"
                        (click)="isAddInspectionOpen = !isAddInspectionOpen"
                        [attr.aria-expanded]="isAddInspectionOpen">
                        <i class="pi" [ngClass]="isAddInspectionOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                      </button>
                    </div>

                    <div class="insp-form" *ngIf="isAddInspectionOpen">
                      <div class="ld-field insp-form__date">
                        <p class="ld-field__label">Pick a Date</p>
                        <p-calendar
                          [(ngModel)]="insertEvent.startdate"
                          [firstDayOfWeek]="1"
                          dateFormat="dd/mm/yy"
                          inputId="basic"
                          placeholder="DD-MM-YY"
                          [ngModelOptions]="{ standalone: true }"
                          [minDate]="minimumDate"
                          [readonlyInput]="true">
                        </p-calendar>
                      </div>

                      <div class="ld-field insp-form__time">
                        <p class="ld-field__label">Start Time</p>
                        <div class="insp-time">
                          <ng-select
                            [(ngModel)]="selectedStartHour"
                            [items]="hours"
                            placeholder="Hr"
                            [clearable]="false"
                            (change)="startHourChange()"
                            [ngModelOptions]="{ standalone: true }"
                            class="_select">
                          </ng-select>
                          <span class="insp-time__sep">:</span>
                          <ng-select
                            [(ngModel)]="selectedStartMinutes"
                            [items]="minutes"
                            placeholder="Min"
                            [clearable]="false"
                            (change)="startMinuteChange()"
                            [ngModelOptions]="{ standalone: true }"
                            class="_select">
                          </ng-select>
                          <ng-select
                            [(ngModel)]="selectedStartDuration"
                            [items]="duration"
                            placeholder="AM"
                            [clearable]="false"
                            (change)="startHourChange()"
                            [ngModelOptions]="{ standalone: true }"
                            class="_select">
                          </ng-select>
                        </div>
                      </div>

                      <div class="ld-field insp-form__time">
                        <p class="ld-field__label">End Time</p>
                        <div class="insp-time">
                          <ng-select
                            [(ngModel)]="selectedEndHour"
                            [items]="hours"
                            placeholder="Hr"
                            [clearable]="false"
                            (change)="endHourChange()"
                            [ngModelOptions]="{ standalone: true }"
                            class="_select">
                          </ng-select>
                          <span class="insp-time__sep">:</span>
                          <ng-select
                            [(ngModel)]="selectedEndMinutes"
                            [items]="minutes"
                            placeholder="Min"
                            [clearable]="false"
                            (change)="endMinuteChange()"
                            [ngModelOptions]="{ standalone: true }"
                            class="_select">
                          </ng-select>
                          <ng-select
                            [(ngModel)]="selectedEndDuration"
                            [items]="duration"
                            placeholder="AM"
                            [clearable]="false"
                            (change)="endHourChange()"
                            [ngModelOptions]="{ standalone: true }"
                            class="_select">
                          </ng-select>
                        </div>
                      </div>

                      <div class="insp-form__actions">
                        <button (click)="insertEventInspection()" [class.disabled]="event_loading" class="_outline-btn">
                          {{ editingInspection ? 'Update' : 'Add' }}
                        </button>
                        <button class="_cancel-btn ml-2" *ngIf="editingInspection" (click)="cancelInspectionEdit()">Cancel</button>
                      </div>
                    </div>

                    <p class="insp-note primary-color">Changes will not be pushed to any portals unless the listing is saved.</p>
                  </div>

                  <div class="ld-card mb-3" *ngIf="property_inspection_list?.length > 0">
                    <div class="ld-card__head">
                      <p class="ld-card__title"><i class="ld-card__icon pi pi-calendar"></i>Upcoming Inspections</p>
                    </div>
                    <div class="insp-table">
                      <div class="insp-row insp-row--head">
                        <span>Date</span>
                        <span>Start Time</span>
                        <span>End Time</span>
                        <span>Type</span>
                        <span>Notes</span>
                        <span class="insp-row__actions">Actions</span>
                      </div>
                      <div class="insp-row" *ngFor="let inspection of property_inspection_list">
                        <p class="insp-row__date">{{ inspection.event.start.dateTime | wallClock | date: 'EEE, dd MMM y' }}</p>
                        <p class="insp-row__time">{{ inspection.start_time }}</p>
                        <p class="insp-row__time">{{ inspection.end_time }}</p>
                        <p class="insp-row__type">{{ inspection.type || '-' }}</p>
                        <p class="insp-row__notes">{{ inspection.event?.description || '-' }}</p>
                        <div class="insp-row__actions">
                          <a href="javascript:void(0)" pTooltip="Edit" tooltipPosition="top" (click)="editInspection(inspection)">
                            <i class="pi pi-pencil f-14"></i>
                          </a>
                          <a href="javascript:void(0)" pTooltip="Delete" tooltipPosition="top" (click)="deleteAppointment(inspection, 'apt')">
                            <i class="pi pi-trash f-14"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="ld-card" *ngIf="past_inspection?.length > 0">
                    <div class="ld-card__head">
                      <p class="ld-card__title"><i class="ld-card__icon pi pi-history"></i>Past Inspections</p>
                    </div>
                    <div class="insp-table">
                      <div class="insp-row insp-row--head">
                        <span>Date</span>
                        <span>Start Time</span>
                        <span>End Time</span>
                        <span>Type</span>
                        <span>Notes</span>
                        <span class="insp-row__actions"></span>
                      </div>
                      <div class="insp-row" *ngFor="let inspection of past_inspection">
                        <p class="insp-row__date">{{ inspection.event.start.dateTime | wallClock | date: 'EEE, dd MMM y' }}</p>
                        <p class="insp-row__time">{{ inspection.start_time }}</p>
                        <p class="insp-row__time">{{ inspection.end_time }}</p>
                        <p class="insp-row__type">{{ inspection.type || '-' }}</p>
                        <p class="insp-row__notes">{{ inspection.event?.description || '-' }}</p>
                        <div class="insp-row__actions"></div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noAgent>
                  <div class="ld-card d-flex align-items-center">
                    <img [src]="common_images?.stream_new" class="email-connect mr-4" />
                    <p class="f-12">Please select and connect Listing Agent</p>
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #listingNotInspection>
                <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
              </ng-template>
            </div>
            <div
              id="legal"
              role="tabpanel"
              aria-labelledby="pills-legal-tab"
              tabindex="0"
              class="tab-pane fade {{ activeIndex === 3 && 'show active' }}">
              <ng-container *ngIf="property_id || insertedPropertyId; else listingNotLegal">
                <div class="sticky-sidebar">
                  <div class="ld-card mb-3">
                    <div class="ld-card__head">
                      <p class="ld-card__title"><i class="ld-card__icon pi pi-file"></i>Contract</p>
                      <div class="d-flex align-items-center">
                        <div *ngIf="selectedRows.length > 0">
                          <button class="_outline-btn mr-2" (click)="changeContractStatus('Accepted')">Accept</button>
                          <button class="_outline-btn mr-2" (click)="changeContractStatus('Declined')">Decline</button>
                        </div>
                        <ng-select
                          [items]="accept_decline"
                          style="width: 185px"
                          name="acceptDecline"
                          bindLabel="tag_name"
                          bindValue="tag_name"
                          [searchable]="true"
                          [clearable]="false"
                          placeholder="Offer Status"
                          (change)="filterContract($event)"
                          class="_select">
                        </ng-select>
                        <ng-container
                          *ngIf="
                            userPermission.includes('contract.manage') ||
                            userPermission.includes('contract.add') ||
                            userRole == 'administrators' ||
                            userRole == 'master admin'
                          ">
                          <button class="_addNew ml-2" (click)="openRightModal(null, 'add_contract')">
                            <i class="f-12 pi pi-plus"></i>
                          </button>
                        </ng-container>
                      </div>
                    </div>
                    <div class="position-relative">
                      <div
                        class="s-custom-entity-records scrol_ mt-2 mob-table"
                        style="max-height: 500px"
                        (scroll)="onLegalScroll($event)"
                        #legalScrollableElement>
                        <i class="pi pi-arrow-up" (click)="legalScrollToTop()" *ngIf="legalScrollTop > 50"></i>
                        <p-table
                          styleClass="pagination-dropdown"
                          scrollWidth="100%"
                          dataKey="_id"
                          [value]="contract_list"
                          [rows]="legalRows"
                          [(selection)]="selectedRows">
                          <ng-template pTemplate="header">
                            <tr>
                              <th style="width: 25px"></th>
                              <th>
                                <div class="flex_th">
                                  <p>Purchaser</p>
                                  <p-sortIcon field="buyer" [pSortableColumn]="'buyer'"></p-sortIcon>
                                </div>
                              </th>
                              <th>
                                <div class="flex_th">
                                  <p>Offer Price</p>
                                  <p-sortIcon field="contractPrice" [pSortableColumn]="'contractPrice'"></p-sortIcon>
                                </div>
                              </th>
                              <th>
                                <div class="flex_th">
                                  <p>Offer Date</p>
                                  <p-sortIcon field="dateOffer" [pSortableColumn]="'dateOffer'"></p-sortIcon>
                                </div>
                              </th>
                              <th>
                                <div class="flex_th">
                                  <p>Selling Agent</p>
                                  <p-sortIcon field="sellingAgent" [pSortableColumn]="'sellingAgent'"></p-sortIcon>
                                </div>
                              </th>
                              <th>
                                <div class="flex_th">
                                  <p>Status</p>
                                  <p-sortIcon field="status" [pSortableColumn]="'status'"></p-sortIcon>
                                </div>
                              </th>
                              <th>
                                <div class="flex_th">
                                  <p>Offer Status</p>
                                  <p-sortIcon field="offer_status" [pSortableColumn]="'offer_status'"></p-sortIcon>
                                </div>
                              </th>
                              <th class="pl-0" style="width: 50px"></th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-contract>
                            <tr>
                              <td style="width: 15px">
                                <div
                                  *ngIf="
                                    userPermission.includes('contract.manage') ||
                                    userPermission.includes('contract.edit') ||
                                    userRole == 'administrators' ||
                                    userRole == 'master admin'
                                  ">
                                  <p-tableCheckbox [value]="contract"></p-tableCheckbox>
                                </div>
                              </td>
                              <td
                                class="cursor-pointer text-captilize"
                                [ngStyle]="{
                                  color: contract?.offer_status === 'Cancelled' ? 'lightgray' : '#1a2f45',
                                }"
                                (click)="openRightModal(contract, 'edit_contract')">
                                <p>{{ contract?.buyer }}</p>
                              </td>
                              <td
                                class="cursor-pointer text-captilize"
                                [ngStyle]="{
                                  color: contract?.offer_status === 'Cancelled' ? 'lightgray' : '#1a2f45',
                                }"
                                (click)="openRightModal(contract, 'edit_contract')">
                                <p *ngIf="contract?.offerPrice">{{ contract?.offerPrice | customCurrency }}</p>
                              </td>
                              <td
                                class="cursor-pointer text-captilize"
                                [ngStyle]="{
                                  color: contract?.offer_status === 'Cancelled' ? 'lightgray' : '#1a2f45',
                                }"
                                (click)="openRightModal(contract, 'edit_contract')">
                                <p>{{ contract?.dateOffer | date: 'd MMM y' }}</p>
                              </td>
                              <td
                                class="cursor-pointer text-captilize"
                                [ngStyle]="{
                                  color: contract?.offer_status === 'Cancelled' ? 'lightgray' : '#1a2f45',
                                }"
                                (click)="openRightModal(contract, 'edit_contract')">
                                <p>{{ contract?.sellingAgent }}</p>
                              </td>
                              <td
                                class="cursor-pointer text-captilize"
                                [ngStyle]="{
                                  color: contract?.offer_status === 'Cancelled' ? 'lightgray' : '#1a2f45',
                                }"
                                (click)="openRightModal(contract, 'edit_contract')">
                                <p>{{ contract?.contractStatus }}</p>
                              </td>
                              <td
                                class="cursor-pointer text-captilize"
                                [ngStyle]="{
                                  color: contract?.offer_status === 'Cancelled' ? 'lightgray' : '#1a2f45',
                                }"
                                (click)="openRightModal(contract, 'edit_contract')">
                                <p>{{ contract?.offer_status }}</p>
                              </td>
                              <td>
                                <ng-container
                                  *ngIf="
                                    userPermission.includes('contract.manage') ||
                                    userPermission.includes('contract.delete') ||
                                    userRole == 'administrators' ||
                                    userRole == 'master admin'
                                  ">
                                  <a class="delete-btn cursor-pointer text-captilize" (click)="deleteContract(contract?._id, $event)">
                                    <img [src]="common_images?.delete_icon" alt="delete" />
                                  </a>
                                </ng-container>
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr class="border-0">
                              <td colspan="7">No record found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                    <p class="legal-records" *ngIf="contract_list?.length > 0">{{ 'Records: ' + contract_list?.length }}</p>
                  </div>

                  <div class="ld-card mb-3">
                    <div class="ld-card__head">
                      <p class="ld-card__title"><i class="ld-card__icon pi pi-file-edit"></i>Selling Agreement Details</p>
                    </div>
                    <div class="ld-row ld-row--4">
                      <div class="ld-field">
                        <p class="ld-field__label">Selling Agreement Start Date</p>
                        <p-calendar
                          [style]="{ width: '100%' }"
                          [ngClass]="{
                            '_input-error': editProperty.controls['selling_agreement_start_date'].hasError('required') && submitted,
                          }"
                          [inputStyle]="{ width: '100%' }"
                          dateFormat="dd/mm/yy"
                          [firstDayOfWeek]="1"
                          class="_input"
                          formControlName="selling_agreement_start_date"
                          [readonlyInput]="true">
                        </p-calendar>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Selling Agreement End Date</p>
                        <p-calendar
                          [style]="{ width: '100%' }"
                          [ngClass]="{
                            '_input-error': editProperty.controls['selling_agreement_end_date'].hasError('required') && submitted,
                          }"
                          [inputStyle]="{ width: '100%' }"
                          dateFormat="dd/mm/yy"
                          firstDayOfWeek="1"
                          class="_input"
                          formControlName="selling_agreement_end_date"
                          [readonlyInput]="true">
                        </p-calendar>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Agreed Marketing Spend</p>
                        <app-price-input
                          [field_value]="editProperty.controls['agreed_marketing_spend'].value"
                          [isRequire]="editProperty.controls['agreed_marketing_spend'].hasError('required') && submitted ? true : false"
                          (onUpdate)="updatePrice($event, 'agreed_marketing_spend')">
                        </app-price-input>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Marketing Payable By</p>
                        <ng-select
                          [ngClass]="{
                            '_input-error': editProperty.controls['marketing_payable_by'].hasError('required') && submitted,
                          }"
                          formControlName="marketing_payable_by"
                          [items]="marketing_payable_by_array"
                          [searchable]="true"
                          bindLabel="value"
                          bindValue="value"
                          placeholder="Select Marketing Payable By"
                          class="_select">
                        </ng-select>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Commission %<br />Inclusive of GST</p>
                        <app-price-input
                          [field_value]="editProperty.controls['percentage_inclusive_of_gst'].value"
                          [isRequire]="editProperty.controls['percentage_inclusive_of_gst'].hasError('required') && submitted ? true : false"
                          (onUpdate)="updatePrice($event, 'percentage_inclusive_of_gst')">
                        </app-price-input>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">$ Amount<br />Inclusive of GST</p>
                        <app-price-input
                          [field_value]="editProperty.controls['amount_inclusive_of_gst'].value"
                          [isRequire]="editProperty.controls['amount_inclusive_of_gst'].hasError('required') && submitted ? true : false"
                          (onUpdate)="updatePrice($event, 'amount_inclusive_of_gst')">
                        </app-price-input>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Commission Payable</p>
                        <ng-select
                          formControlName="commission_payable"
                          [ngClass]="{
                            '_input-error': editProperty.controls['commission_payable'].hasError('required') && submitted,
                          }"
                          [items]="listingService.listingPropertyOption.commission_payable_array"
                          [searchable]="true"
                          bindLabel="tag_name"
                          bindValue="tag_name"
                          placeholder="Select Commission Payable"
                          class="_select">
                        </ng-select>
                      </div>
                      <div class="ld-field">
                        <p class="ld-field__label">Documents</p>
                        <input
                          type="file"
                          #legalSellingDocument
                          (change)="onLegalSellingDocument($event)"
                          [hidden]="1"
                          accept=".svg,image/*"
                          multiple="false" />
                        <button class="_outline-btn" (click)="legalSellingDocument.click()"><i class="pi pi-plus mr-1 f-12"></i> New</button>
                      </div>
                    </div>

                    <div class="legal-files" *ngIf="legal_files?.length > 0">
                      <p class="ld-field__label">Files</p>
                      <div class="legal-files__list">
                        <a class="legal-files__item" *ngFor="let file of legal_files; let i = index" [href]="S3Path + file?.path" target="_blank">
                          <i class="pi pi-file-pdf f-20 mb-2"></i>
                          <p>{{ file?.name?.split('.')[0] }}</p>
                        </a>
                      </div>
                    </div>

                    <div class="ld-field mb-0 mt-2">
                      <p class="ld-field__label">Notes</p>
                      <textarea
                        cols="30"
                        style="min-height: 100px !important"
                        pInputTextarea
                        [ngClass]="{
                          '_input-error': editProperty.controls['selling_agreement_notes'].hasError('required') && submitted,
                        }"
                        formControlName="selling_agreement_notes"></textarea>
                    </div>
                  </div>

                  <div class="ld-card mb-3">
                    <div class="ld-card__head">
                      <p class="ld-card__title"><i class="ld-card__icon pi pi-map"></i>Property Legal Details</p>
                    </div>
                    <div class="ld-row ld-row--4">
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">Lot</p>
                        <input
                          class="_input"
                          formControlName="lot"
                          (keyup)="transformPrice($event, 'value')"
                          [ngClass]="{
                            '_input-error': editProperty.controls['lot'].hasError('required') && submitted,
                          }" />
                      </div>
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">On Subdivision</p>
                        <input
                          class="_input"
                          formControlName="subdivision"
                          (keyup)="transformPrice($event, 'value')"
                          [ngClass]="{
                            '_input-error': editProperty.controls['subdivision'].hasError('required') && submitted,
                          }" />
                      </div>
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">Title Reference</p>
                        <input
                          class="_input"
                          formControlName="titleref"
                          (keyup)="transformPrice($event, 'value')"
                          [ngClass]="{
                            '_input-error': editProperty.controls['titleref'].hasError('required') && submitted,
                          }" />
                      </div>
                      <div class="ld-field mb-0">
                        <p class="ld-field__label">Legal Address</p>
                        <input
                          class="_input"
                          formControlName="legaladdress"
                          (keyup)="transformPrice($event, 'value')"
                          [ngClass]="{
                            '_input-error': editProperty.controls['legaladdress'].hasError('required') && submitted,
                          }" />
                      </div>
                    </div>
                  </div>

                  <div class="ld-card">
                    <div class="ld-card__head">
                      <p class="ld-card__title"><i class="ld-card__icon pi pi-users"></i>Vendor Legal Details</p>
                    </div>
                    <div class="ld-row ld-row--2">
                      <div class="ld-field create-task-dropdown mb-0">
                        <p class="ld-field__label">Legal Name</p>
                        <re-multiselect
                          [module]="'contacts'"
                          [truncate]="13"
                          [selected_ids]="editProperty.get('legalname')?.value"
                          (onUpdate)="onUpdateMSelect($event, 'legalname')"
                          [placeholder]="'Select Contact'"
                          (createNew)="openRightModal(null, 'add_contact')"
                          [isCreateNew]="true"
                          [isEmail]="true"
                          [style]="{ width: '100%' }"
                          (editRecord)="editRecord($event)">
                        </re-multiselect>
                      </div>
                      <div class="ld-field create-task-dropdown mb-0">
                        <p class="ld-field__label">Solicitor</p>
                        <re-multiselect
                          [module]="'contacts'"
                          [truncate]="13"
                          [selected_ids]="editProperty.get('solicitors')?.value"
                          [type]="'Company'"
                          (onUpdate)="solicitorContact($event)"
                          [placeholder]="'Select Company'"
                          (createNew)="openRightModal(null, 'add_contact')"
                          [isCreateNew]="true"
                          [style]="{ width: '100%' }"
                          (editRecord)="editRecord($event)"
                          [isEmail]="true">
                        </re-multiselect>
                      </div>
                      <div class="ld-field create-task-dropdown mb-0">
                        <p class="ld-field__label">Solicitor's Contact</p>
                        <ng-select
                          [items]="solicitor_contact"
                          bindLabel="full_name"
                          bindValue="_id"
                          [searchable]="true"
                          [multiple]="true"
                          formControlName="solicitorscontract"
                          [ngClass]="{
                            '_input-error': editProperty.controls['solicitorscontract'].hasError('required') && submitted,
                          }"
                          placeholder="Select Contact"
                          [clearable]="false"
                          class="task-contact _select">
                          <ng-template ng-label-tmp let-item="item">
                            <div class="d-flex align-items-center cursor-pointer">
                              <i class="pi pi-times-circle mr-2 ml-1" (click)="clear(item?._id, 'S_C')"></i>
                              <p class="ng-value-label" (click)="openRightModal(item, 'edit_contact')">
                                {{ item.full_name }}
                              </p>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <span>{{ item.full_name }}</span>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #listingNotLegal>
                <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
              </ng-template>
            </div>
            <div
              id="document"
              role="tabpanel"
              aria-labelledby="pills-document-tab"
              tabindex="0"
              class="tab-pane listing-pane fade {{ activeIndex === 4 && 'show active' }}">
              <div class="ld-card__head">
                <div>
                  <p class="ld-card__title"><i class="ld-card__icon pi pi-folder"></i>Files</p>
                  <p class="ld-card__note">Documents attached to this listing.</p>
                </div>
              </div>
              <ng-container *ngIf="property_id || insertedPropertyId; else listingNotDoc">
                <ng-container *ngIf="isDocuments">
                  <div class="sticky-sidebar">
                    <div class="site-card p-0 row lib-content px-3 library cs-br-16">
                      <app-library-view-mode
                        *ngIf="lmService.listing_show_div == 'edit_listing_property' || insertedPropertyId?.length > 0 || property_id"
                        [librarydata]="libraryDataEmitter"
                        [hidePropertyLibrary]="true"
                        category="useroffice"
                        [tooltipText]="'Only Upload PDF File'"
                        [propertyId]="property_id || insertedPropertyId"
                        [isBackBtnShown]="true"
                        [isBackBtnIndex]="1"
                        defaultopen="documents"
                        [isListingLibrary]="true"
                        (LibraryOutputData)="GetLibraryData($event)">
                      </app-library-view-mode>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #listingNotDoc>
                <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
              </ng-template>
            </div>
            <div
              id="portal"
              role="tabpanel"
              [class.disabled]="
                !(
                  userRole == 'administrators' ||
                  userRole == 'master admin' ||
                  userRole == 'operations manager' ||
                  userPermission.includes('listing_portal.update')
                )
              "
              aria-labelledby="pills-portal-tab"
              tabindex="0"
              class="tab-pane narrow-pane fade {{ activeIndex === 6 && 'show active' }}">
              <ng-container *ngIf="property_id || insertedPropertyId; else listingNotPortal">
                <form [formGroup]="editProperty">
                  <div class="ld-card">
                    <div class="ld-card__head">
                      <div>
                        <p class="ld-card__title"><i class="ld-card__icon pi pi-desktop"></i>Portals</p>
                        <p class="ld-card__note">Select which portals this listing will be pushed to.</p>
                      </div>
                    </div>

                    <!-- Every portal is the same four things, so they share one grid and line up
                         column by column instead of each row placing its own bootstrap columns. -->
                    <div class="portals-table">
                      <div class="portals-row portals-row--head">
                        <span>Portal</span>
                        <span>Domain / Email</span>
                        <span class="portals-row__status">Status</span>
                        <span class="portals-row__toggle">Push to Portal</span>
                      </div>

                      <div class="portals-row">
                        <p class="portals-row__name" [ngClass]="{ 'text-danger': domain_failure?.web_push_failure }">Company Website</p>
                        <div class="portals-row__detail"></div>
                        <div class="portals-row__status">
                          <i
                            class="f-18 pi pi-exclamation-triangle cursor-pointer"
                            [pTooltip]="web_published_at ? (web_published_at | date: 'dd/MM/yyyy') : 'Not published yet'"
                            tooltipPosition="top"
                            [ngClass]="{ 'text-danger': company_website_error_set == true }"
                            (click)="company_website_error_set = !company_website_error_set"></i>
                        </div>
                        <div class="portals-row__toggle">
                          <div class="task-switch-wrap">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked="false"
                                formControlName="isWpPush"
                                [ngClass]="{
                                  '_input-error': editProperty.controls['isWpPush'].hasError('required') && submitted,
                                }"
                                (change)="onChangeWp($event)" />
                              <span class="slider"></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="portals-row">
                        <div class="portals-row__name">
                          <p [ngClass]="{ 'text-danger': domain_failure?.domain_push_failure }">Domain</p>
                          <a
                            class="f-12 remmi-color"
                            *ngIf="selectedProperty?.domain_listing_url"
                            [href]="selectedProperty?.domain_listing_url"
                            target="_blank">
                            View Listing
                          </a>
                        </div>
                        <div class="portals-row__detail">
                          <input
                            class="_input"
                            formControlName="otherEmail"
                            placeholder="Enter domain or email"
                            [ngClass]="{
                              '_input-error': editProperty.controls['otherEmail'].hasError('required') && submitted,
                            }" />
                        </div>
                        <div class="portals-row__status">
                          <i
                            class="f-18 pi pi-exclamation-triangle cursor-pointer"
                            [pTooltip]="domain_published_at ? (domain_published_at | date: 'dd/MM/yyyy') : 'Not published yet'"
                            tooltipPosition="top"
                            [ngClass]="{ 'text-danger': domain_error_set == true }"
                            (click)="domain_error_set = !domain_error_set"></i>
                        </div>
                        <div class="portals-row__toggle">
                          <div class="task-switch-wrap">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked="false"
                                [ngClass]="{
                                  '_input-error': editProperty.controls['isDomainCrm'].hasError('required') && submitted,
                                }"
                                formControlName="isDomainCrm"
                                (change)="onChangeDomain($event)" />
                              <span class="slider"></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="portals-row" [class.disabled]="selectedProperty?.is_rea_disable">
                        <p class="portals-row__name" [ngClass]="{ 'text-danger': domain_failure?.rea_push_failure }">realestate.com.au</p>
                        <div class="portals-row__detail"></div>
                        <div class="portals-row__status">
                          <i
                            class="f-18 pi pi-exclamation-triangle cursor-pointer"
                            [pTooltip]="rea_published_at ? (rea_published_at | date: 'dd/MM/yyyy') : 'Not published yet'"
                            tooltipPosition="top"
                            [ngClass]="{ 'text-danger': rea_error_set == true }"
                            (click)="rea_error_set = !rea_error_set"></i>
                        </div>
                        <div class="portals-row__toggle">
                          <div class="task-switch-wrap">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked="false"
                                formControlName="isReaCrm"
                                [ngClass]="{
                                  '_input-error': editProperty.controls['isReaCrm'].hasError('required') && submitted,
                                }"
                                (change)="onChangeRea($event)" />
                              <span class="slider"></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="portals-row">
                        <p class="portals-row__name" [ngClass]="{ 'text-danger': domain_failure?.homely_push_failure }">Homely</p>
                        <div class="portals-row__detail"></div>
                        <div class="portals-row__status">
                          <i
                            class="f-18 pi pi-exclamation-triangle cursor-pointer"
                            [pTooltip]="market_place_published_at ? (market_place_published_at | date: 'dd/MM/yyyy') : 'Not published yet'"
                            tooltipPosition="top"
                            [ngClass]="{ 'text-danger': homely_error_set == true }"
                            (click)="homely_error_set = !homely_error_set"></i>
                        </div>
                        <div class="portals-row__toggle">
                          <div class="task-switch-wrap">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked="false"
                                formControlName="homley_portal"
                                [ngClass]="{
                                  '_input-error': editProperty.controls['homley_portal'].hasError('required') && submitted,
                                }"
                                (change)="onHomley($event)" />
                              <span class="slider"></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="portals-row">
                        <p class="portals-row__name" [ngClass]="{ 'text-danger': domain_failure?.market_place_push_failure }">Market Place</p>
                        <div class="portals-row__detail"></div>
                        <div class="portals-row__status">
                          <i
                            class="f-18 pi pi-exclamation-triangle cursor-pointer"
                            [pTooltip]="market_place_published_at ? (market_place_published_at | date: 'dd/MM/yyyy') : 'Not published yet'"
                            tooltipPosition="top"
                            [ngClass]="{ 'text-danger': market_place_error_set == true }"
                            (click)="market_place_error_set = !market_place_error_set"></i>
                        </div>
                        <div class="portals-row__toggle">
                          <div class="task-switch-wrap">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked="false"
                                formControlName="market_place"
                                [ngClass]="{
                                  '_input-error': editProperty.controls['market_place'].hasError('required') && submitted,
                                }"
                                (change)="onMarketPlace($event)" />
                              <span class="slider"></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="portals-row">
                        <p class="portals-row__name" [ngClass]="{ 'text-danger': domain_failure?.real_estate_view_push_failure }">Real Estate View</p>
                        <div class="portals-row__detail"></div>
                        <div class="portals-row__status">
                          <i
                            class="f-18 pi pi-exclamation-triangle cursor-pointer"
                            [pTooltip]="real_estate_view_publised_at ? (real_estate_view_publised_at | date: 'dd/MM/yyyy') : 'Not published yet'"
                            tooltipPosition="top"
                            [ngClass]="{ 'text-danger': real_estate_view_error_set == true }"
                            (click)="real_estate_view_error_set = !real_estate_view_error_set"></i>
                        </div>
                        <div class="portals-row__toggle">
                          <div class="task-switch-wrap">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked="false"
                                formControlName="real_estate_view"
                                [ngClass]="{
                                  '_input-error': editProperty.controls['real_estate_view'].hasError('required') && submitted,
                                }"
                                (change)="onRealEstateView($event)" />
                              <span class="slider"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </ng-container>
              <ng-template #listingNotPortal>
                <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
              </ng-template>
            </div>
          </div>
        </div>
        <!-- Same rule as the header pair: only the tabs that edit the listing form get to save it.
             It follows the tab's content rather than being pulled up over it. -->
        <div class="listing-save-row justify-content-end" *ngIf="canSaveListing && !isListingReadOnly">
          <ng-container *ngxPermissionsOnly="['allproperties.manage', 'allproperties.add']">
            <div
              class="{{ mobToggle ? 'd-none' : 'd-flex' }} align-items-center justify-content-end"
              *ngIf="
                lmService.listing_show_div == 'add_listing_from_property' ||
                lmService.listing_show_div == 'add_listing_property' ||
                lmService.listing_show_div == 'add_listing_property_listing'
              ">
              <button
                style="margin-top: 4px"
                class="mb-2 mr-2 _outline-btn btn-sm"
                (click)="CreateProperty('onlyCreate')"
                [class.disabled]="submitDisable || isPrivate">
                Save
              </button>
              <button class="_primary-btn btn-sm mt-1 mb-2 mr-2" (click)="CreateProperty('create')" [class.disabled]="submitDisable || isPrivate">
                Save & Close
              </button>
            </div>
          </ng-container>
          <ng-container *ngxPermissionsOnly="['allproperties.manage', 'allproperties.edit']">
            <div
              *ngIf="lmService.listing_show_div == 'edit_listing_property'"
              class="{{ mobToggle ? 'd-none' : 'd-flex' }} align-items-center justify-content-between">
              <div></div>
              <div>
                <button
                  style="margin-top: 4px"
                  class="_outline-btn mr-2 btn-sm"
                  (click)="updateProperty('onlyUpdate')"
                  [class.disabled]="submitDisable || isPrivate">
                  Save
                </button>
                <button class="_primary-btn mr-2 btn-sm mt-1" (click)="updateProperty('update')" [class.disabled]="submitDisable || isPrivate">
                  Save & Close
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
  </ng-template>
</ng-template>

<ng-template #secondPanel>
  <div class="col-lg-12 position-relative">
    <ng-container
      *ngIf="
        userRole == 'administrators' ||
        userRole == 'master admin' ||
        userRole == 'operations manager' ||
        userPermission.includes('listing_process.view')
      ">
      <ng-container *ngFlag="'automation'">
        <img
          [src]="common_images?.automation_icon"
          [ngClass]="{ 'icon-red': no_process_run === true }"
          class="process-setting"
          (click)="GetListingWorkflowProcesses()"
          *ngIf="!mobToggle" />
      </ng-container>
    </ng-container>
    <div
      class="mb-4 pb-4 position-relative justify-content-between overflow-hidden h-100 stream-details pt-0 {{ mobToggle ? 'px-0' : 'pr-0' }}"
      style="border-top: 0px; border-right: 0px">
      <div class="tab-content" id="pills-tabContent">
        <div id="Lead" role="tabpanel" aria-labelledby="pills-Lead-tab" tabindex="0" class="tab-pane {{ activeIndexs === 1 && 'show active' }} fade">
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotLead">
            <!-- Built only while the tab is open: the leads page loads its own list, chart and
                 preferences, and none of that should run behind the other tabs. -->
            <div class="listing-leads-page" *ngIf="leadsPageTemplate && activeIndexs === 1">
              <ng-container
                *ngTemplateOutlet="
                  leadsPageTemplate;
                  context: {
                    $implicit: selectedProperty,
                    listingId: property_id || insertedPropertyId,
                    leadRefresh: leadListRefresh.asObservable(),
                    lotName: residentialLotName,
                  }
                "></ng-container>
            </div>
            <div *ngIf="!leadsPageTemplate" class="d-flex align-items-center flex-wrap w-100 justify-content-between mt-2 mob-table">
              <div class="ml-2" *ngIf="all_leads?.length">
                <p>{{ 'Records: ' + all_leads?.length }}</p>
              </div>
              <div class="d-flex align-items-center" *ngIf="!all_leads?.length">
                <img [src]="common_images?.enquiry" class="w-50px" />
                <p class="f-12 ml-3">Assign leads to listing.</p>
              </div>
              <button *ngxPermissionsOnly="['lead.add']" class="_outline-btn" (click)="newLead(true)">
                <i class="pi pi-plus mr-2 f-12 primary-color"></i> New Lead
              </button>
            </div>
            <ng-container *ngIf="!leadsPageTemplate && all_leads?.length">
              <div class="position-relative w-100 mt-3 {{ mobToggle && all_leads?.length == 1 ? 'mb-3' : '' }}">
                <div class="s-custom-entity-records lead-table scrol_ mob-table" (scroll)="onsideLeadScroll($event)" #sideLeadScrollableElement>
                  <i class="pi pi-arrow-up" (click)="sideLeadScrollToTop()" *ngIf="sideLeadScrollTop > 50"></i>
                  <p-table
                    id="customentitydatalist"
                    [autoLayout]="true"
                    [value]="all_leads"
                    styleClass="history-table"
                    dataKey="_id"
                    [rowHover]="false"
                    [rows]="sideLeadRows"
                    [tableStyle]="{ 'min-width': 'auto' }">
                    <ng-template pTemplate="header">
                      <tr class="no-wrap">
                        <th style="min-width: 60px; width: 60px">&nbsp;</th>
                        <th style="min-width: 150px; width: 150px">
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Full Name</p>
                            <p-sortIcon [field]="'full_name'" [pSortableColumn]="'full_name'"></p-sortIcon>
                          </div>
                        </th>
                        <th style="min-width: 180px; width: 180px">
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Email</p>
                            <p-sortIcon [field]="'email'" [pSortableColumn]="'email'"></p-sortIcon>
                          </div>
                        </th>
                        <th style="min-width: 110px; width: 110px">
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Mobile</p>
                            <p-sortIcon [field]="'mobile_phone'" [pSortableColumn]="'mobile_phone'"></p-sortIcon>
                          </div>
                        </th>
                        <th style="min-width: 100px; width: 100px">
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Status</p>
                            <p-sortIcon [field]="'lead_status'" [pSortableColumn]="'lead_status'"></p-sortIcon>
                          </div>
                        </th>
                        <th style="min-width: 110px; width: 120px">
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Lead Source</p>
                            <p-sortIcon [field]="'lead_source'" [pSortableColumn]="'lead_source'"></p-sortIcon>
                          </div>
                        </th>
                        <th style="min-width: 100px; width: 100px">
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Date</p>
                            <p-sortIcon [field]="'created_at'" [pSortableColumn]="'created_at'"></p-sortIcon>
                          </div>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-lead let-columns="columns">
                      <tr class="cp">
                        <td style="width: 60px; padding-left: 10px !important">
                          <div class="d-flex align-items-center mt-1">
                            <i class="cursor-pointer f-16 mr-3 pi pi-user-minus" pTooltip="Remove Assigned" (click)="removeAssignment(lead)"></i>
                            <i class="cursor-pointer f-16 pi pi-clone" pTooltip="Duplicate" (click)="duplicateRecords(lead)"></i>
                          </div>
                        </td>
                        <td (click)="editLead(lead)" [ngStyle]="{ 'font-weight': lead?.is_read === false ? 'bold' : 'normal' }">
                          {{ lead?.full_name || '' }}
                        </td>
                        <td
                          (click)="editLead(lead)"
                          class="overflow-hidden"
                          [ngStyle]="{ 'font-weight': lead?.is_read === false ? 'bold' : 'normal' }">
                          {{ lead?.email }}
                        </td>
                        <td (click)="editLead(lead)" [ngStyle]="{ 'font-weight': lead?.is_read === false ? 'bold' : 'normal' }">
                          {{ lead?.mobile_phone }}
                        </td>
                        <td (click)="editLead(lead)" [ngStyle]="{ 'font-weight': lead?.is_read === false ? 'bold' : 'normal' }">
                          {{ lead?.lead_status }}
                        </td>
                        <td (click)="editLead(lead)" [ngStyle]="{ 'font-weight': lead?.is_read === false ? 'bold' : 'normal' }">
                          {{ lead?.lead_source }}
                        </td>
                        <td (click)="editLead(lead)" [ngStyle]="{ 'font-weight': lead?.is_read === false ? 'bold' : 'normal' }">
                          {{ lead?.created_at | date: 'dd/MM/yy' }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="5">No record found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #listingNotLead>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
        <div
          id="Appointments"
          role="tabpanel"
          aria-labelledby="pills-Appointments-tab"
          tabindex="0"
          class="tab-pane listing-pane fade {{ activeIndexs === 2 && 'show active' }}">
          <div class="ld-card__head">
            <div>
              <p class="ld-card__title"><i class="ld-card__icon pi pi-calendar"></i>Calendar</p>
              <p class="ld-card__note">Appointments and events scheduled against this listing.</p>
            </div>
          </div>
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotApp">
            <div class="row pl-3 pb-3 pr-3 mob-table">
              <ng-container *ngIf="selectedProperty?.agent">
                <div class="col-sm-12 px-0">
                  <ng-container *ngIf="!emailConnected && isSalesAgent == false && isPropertyAgent == false">
                    <div class="d-flex w-400px align-items-center flex-wrap {{ mobToggle ? 'mt-3' : '' }}">
                      <div>
                        <div class="d-flex">
                          <button *ngIf="!emailConnected && !showConnectBtns" class="_outline-btn" (click)="showConnectBtns = true">
                            Connect Your Account
                          </button>
                          <ng-container *ngIf="!emailConnected && showConnectBtns">
                            <button (click)="gsuiteLogin()" class="_outline-btn mr-2">G Suite</button>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="my-3 {{ mobToggle ? 'd-block' : 'd-flex' }} ">
                    <button
                      *ngIf="!addNewApt && userPermission.includes('property-appointment.manage') == true"
                      (click)="addNewAppointment()"
                      class="preview-btn {{ mobToggle ? 'mr-2 my-2' : '' }}">
                      <i class="pi pi-plus mr-1 f-12"></i> Create New
                    </button>
                    <ng-container *ngFlag="'my_task'">
                      <button class="preview-btn ml-auto" *ngxPermissionsOnly="['task.create']" (click)="addNewTask(null, true)">
                        <i class="pi pi-plus mr-2 f-12"></i>New Task
                      </button>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="mobToggle">
                    <ng-container *ngTemplateOutlet="calendarAppointment"></ng-container>
                  </ng-container>
                  <div
                    class="{{
                      dynamicPanelSizes[1] <= 35 || mobToggle ? 'd-block' : 'd-flex'
                    }} calendar-views align-items-center justify-content-between">
                    <div class="create-task-dropdown" [ngStyle]="{ width: mobToggle ? '180px' : '100%' }">
                      <ng-select
                        *ngIf="calendarAccessUser?.length > 0"
                        [items]="calendarAccessUser"
                        bindLabel="full_name"
                        bindValue="_id"
                        [searchable]="true"
                        [multiple]="true"
                        [(ngModel)]="activeCalendarUser"
                        placeholder="Select"
                        [clearable]="false"
                        class="w-50 task-contact _select"
                        (change)="getUserCalendarDetail(selectedProperty, true, $event)">
                        <ng-template ng-label-tmp let-item="item">
                          <div class="d-flex align-items-center">
                            <i
                              class="pi pi-times-circle cursor-pointer mr-2 ml-1"
                              (click)="clear(item?._id, 'calendar'); getUserCalendarDetail(selectedProperty, true, item, item?._id)"></i>
                            <p class="ng-value-label">{{ item.full_name }}</p>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <div class="d-flex align-items-center">
                            <p [ngStyle]="{ 'background-color': item.color }" class="cal-color"></p>
                            <p>{{ item.full_name }}</p>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <ng-select
                      [items]="calendar_views"
                      [searchable]="true"
                      [(ngModel)]="cal_view_grid"
                      bindLabel="name"
                      bindValue="value"
                      placeholder="Select"
                      [clearable]="false"
                      (change)="changeViewGrid()"
                      class="{{ mobToggle ? 'w-50 mt-2' : 'w-25' }} _select">
                    </ng-select>
                  </div>
                  <div class="mt-3 agentCalendar">
                    <div class="px-2 d-flex align-items-center">
                      <img class="img-24 dark mr-2" [src]="common_images?.calendar" />
                      <h5 class="text-dark f-14" style="color: #2d303d">Agent Calendar</h5>
                    </div>
                    <i
                      class="pi pi-refresh cursor-pointer f-14 {{ mobToggle ? 'mr-2' : '' }}"
                      (click)="this.isCache = false; getUserCalendarDetail(selectedProperty, true, $event, null, true)"></i>
                  </div>
                  <div [class.hidden-item]="default_view !== 'grid'" class="mt-3">
                    <full-calendar style="margin-top: -5px" [options]="optional" contentHeight="auto" #fullcalendar class="fcal"></full-calendar>
                    <div class="position-fixed bg-primary pop-ov" [class.d-none]="pop_title == ''">
                      <p class="p-2 text-color">{{ pop_title }}</p>
                    </div>
                  </div>
                  <div [class.hidden-item]="default_view !== 'list'">
                    <div class="arrowbuttonsdiv">
                      <img class="img-31 dark mr-2" [src]="images?.left_arrow" (click)="prevList()" title="Previous day" />
                      <img class="img-31 dark mr-2" [src]="images?.right_arrow" (click)="nextList()" title="Next day" />
                    </div>
                    <div class="calendar-views flexCenterEnd" style="margin-top: -25px">
                      <ng-select
                        [items]="calendar_views"
                        [searchable]="true"
                        [(ngModel)]="cal_view_grid"
                        bindLabel="name"
                        bindValue="value"
                        placeholder="Select"
                        [clearable]="false"
                        (change)="changeViewList()"
                        class="w-25 _select">
                      </ng-select>
                    </div>
                    <p class="p-2 f-12" *ngIf="!time_hour?.events?.items?.length">No Appointments</p>
                    <div class="p-3" *ngIf="isFetchedEvent">
                      <ng-container *ngIf="time_hour?.events?.items?.length">
                        <div class="mb-4" *ngFor="let event of time_hour?.events?.items">
                          <ng-container>
                            <p class="f-12 mb-2">
                              {{ event?.start?.dateTime | date: 'EEE, d MMM yy' }}
                            </p>
                            <div class="px-2 py-2 br-10" [ngStyle]="getBgColor(event?.colorId)">
                              <div style="float: right; display: flex; align-items: center">
                                <a
                                  *ngIf="event.hasOwnProperty('kind')"
                                  href="javascript:void(0)"
                                  (click)="getConfirm($event, event)"
                                  style="color: #ccc"
                                  ><i class="pi pi-trash f-12 ml-2"></i
                                ></a>
                              </div>
                              <div class="f-12 line-hight-1-3" [innerHTML]="event.summary"></div>
                              <div class="f-12 ev-desc mt-2 line-hight-1-3" *ngIf="event.description" [innerHTML]="event.description"></div>
                              <p class="f-12 mt-2 text-lowercase d-flex align-items-center" *ngIf="event?.kind == 'calendar#event'">
                                <i class="pi pi-clock f-12 mr-2"></i>
                                {{ event?.start?.dateTime | date: 'h' }} To
                                {{ event?.end?.dateTime | date: 'h:mma' }}
                              </p>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mt-2" style="height: fit-content">
                  <ng-container *ngIf="!mobToggle">
                    <ng-container *ngTemplateOutlet="calendarAppointment"></ng-container>
                  </ng-container>
                  <div class="my-2" *ngFlag="'my_task'">
                    <app-collapse-box [headingClassName]="'f-14'" [isCollapsed]="true" [heading]="'My Tasks'">
                      <div class="mb-3">
                        <p-table
                          dataKey="_id"
                          [value]="todayTasks"
                          [paginator]="isPaginatorVisible('today')"
                          [rows]="5"
                          [rowHover]="false"
                          [showCurrentPageReport]="true"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                          [rowsPerPageOptions]="[5, 10, 15]"
                          [(selection)]="selectedRows">
                          <ng-template pTemplate="header">
                            <tr>
                              <th class="pl-0 f-14 font-weight-normal" style="width: 80%">
                                <p class="_fw-600">Today:</p>
                                {{ todayDate }}
                              </th>
                              <th class="f-14" style="width: 20%">Actions</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-task>
                            <tr>
                              <td class="d-flex align-items-start">
                                <p-tableCheckbox class="mr-2" [value]="task" (click)="application()"></p-tableCheckbox>
                                {{ task?.title }}<br />
                                {{ task?.task_time }}
                              </td>
                              <td>
                                <div class="d-flex align-items-center gap-3">
                                  <i class="pi pi-pencil cursor-pointer" (click)="addNewTask(task, false)" *ngxPermissionsOnly="['task.edit']"> </i>
                                  <ng-container *ngxPermissionsOnly="['task.delete']">
                                    <img
                                      [src]="common_images?.delete_icon"
                                      alt="delete"
                                      width="16px"
                                      (click)="deleteTask(task)"
                                      *ngIf="AuthUser.role === 'Master Admin' || AuthUser._id === task.user_id"
                                      class="cursor-pointer" />
                                  </ng-container>
                                </div>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                      <div class="mb-3">
                        <p-table
                          dataKey="_id"
                          [value]="tomorrowTasks"
                          [paginator]="isPaginatorVisible('tomorrow')"
                          [rows]="5"
                          [rowHover]="false"
                          [showCurrentPageReport]="true"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                          [rowsPerPageOptions]="[5, 10, 15]"
                          [(selection)]="selectedRows">
                          <ng-template pTemplate="header">
                            <tr>
                              <th class="pl-0 f-14 font-weight-normal" style="width: 80%">
                                <p class="_fw-600">Tomorrow:</p>
                                {{ tomorrowDate }}
                              </th>
                              <th class="f-14" style="width: 20%"></th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-task>
                            <tr>
                              <td class="d-flex align-items-start">
                                <p-tableCheckbox class="mr-2" [value]="task" (click)="application()"></p-tableCheckbox>
                                {{ task?.title }}<br />
                                {{ task?.task_time }}
                              </td>
                              <td>
                                <div class="d-flex align-items-center gap-3">
                                  <i class="pi pi-pencil cursor-pointer" (click)="addNewTask(task, false)" *ngxPermissionsOnly="['task.edit']"> </i>
                                  <ng-container *ngxPermissionsOnly="['task.delete']">
                                    <img
                                      [src]="common_images?.delete_icon"
                                      alt="delete"
                                      width="16px"
                                      (click)="deleteTask(task)"
                                      *ngIf="AuthUser.role === 'Master Admin' || AuthUser._id === task.user_id"
                                      class="cursor-pointer" />
                                  </ng-container>
                                </div>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </app-collapse-box>
                  </div>
                  <div class="mb-2">
                    <app-collapse-box [headingClassName]="'f-14'" [heading]="'Inspections'">
                      <div *ngIf="property_apt_list?.length < 6">
                        <ng-container *ngFor="let item of property_apt_list">
                          <div style="background-color: #f8f9fb; border-radius: 12px" class="mb-2 p-3">
                            <div
                              style="float: right; display: flex; align-items: center"
                              *ngIf="
                                item.type == 'Open Home' ||
                                item.type == 'Private Inspection' ||
                                item.type == 'Auction' ||
                                item.type == 'Inspection' ||
                                item.type == 'Meeting' ||
                                item.type == 'Call'
                              ">
                              <a href="javascript:void(0)" (click)="editAppointment(item)"><i class="icon-icon-edit-lock f-18"></i></a>
                              <a href="javascript:void(0)" (click)="deleteAppointment(item, 'apt')" style="color: #ccc">
                                <img [src]="common_images?.delete_icon" alt="delete" width="14px" class="ml-2" />
                              </a>
                            </div>
                            <p
                              *ngIf="
                                item.type != 'Open Home' && item.type != 'Private Inspection' && item.type != 'Auction' && item.type != 'Inspection'
                              "
                              class="f-12 _fw-600 mb-2">
                              <i class="pi pi-info-circle f-12 mr-1"></i>
                              <span style="text-transform: capitalize"> {{ item.event.visibility }}</span>
                              -
                              {{ item.type.substring(item.type.indexOf('#') + 1, item.type.indexOf(':')) }}
                            </p>
                            <p
                              *ngIf="
                                item.type == 'Open Home' || item.type == 'Private Inspection' || item.type == 'Auction' || item.type == 'Inspection'
                              "
                              class="f-12 _fw-600 mb-2">
                              <i class="pi pi-info-circle f-12 mr-1"></i>
                              {{ item.event.availablebusy }} - {{ item.type }}
                            </p>
                            <p class="dim-text mb-2">
                              <i class="pi pi-calendar-times f-12 mr-1"></i>
                              {{ item.event.start.dateTime | wallClock | date: 'd MMM yy' }}
                              {{ item.start_time }} - {{ item.end_time }}
                            </p>
                            <p class="dim-text" *ngIf="item?.event?.location"><i class="pi pi-map-marker f-12 mr-1"></i> {{ item.event.location }}</p>
                          </div>
                        </ng-container>
                      </div>
                      <div class="pt-4" *ngIf="property_apt_list?.length > 5">
                        <ng-container *ngFor="let item of property_apt_list; let idx = index">
                          <div *ngIf="idx < appointmentPageSize" style="background-color: #f8f8f8; border-radius: 10px" class="mb-2 p-3">
                            <div
                              style="float: right; display: flex; align-items: center"
                              *ngIf="
                                item.type == 'Open Home' ||
                                item.type == 'Private Inspection' ||
                                item.type == 'Auction' ||
                                item.type == 'Inspection' ||
                                item.type == 'Meeting' ||
                                item.type == 'Call'
                              ">
                              <a href="javascript:void(0)" (click)="editAppointment(item)"><i class="icon-icon-edit-lock f-18"></i></a>
                              <a href="javascript:void(0)" (click)="deleteAppointment(item, 'apt')" style="color: #ccc">
                                <img [src]="common_images?.delete_icon" alt="delete" width="14px" class="ml-2" />
                              </a>
                            </div>
                            <p
                              *ngIf="
                                item.type != 'Open Home' && item.type != 'Private Inspection' && item.type != 'Auction' && item.type != 'Inspection'
                              "
                              class="f-12 _fw-600 mb-2">
                              <i class="pi pi-info-circle f-12 mr-1"></i>
                              <span style="text-transform: capitalize"> {{ item.event.visibility }}</span>
                              -
                              {{ item.type.substring(item.type.indexOf('#') + 1, item.type.indexOf(':')) }}
                            </p>
                            <p
                              *ngIf="
                                item.type == 'Open Home' || item.type == 'Private Inspection' || item.type == 'Auction' || item.type == 'Inspection'
                              "
                              class="f-12 _fw-600 mb-2">
                              <i class="pi pi-info-circle f-12 mr-1"></i>
                              {{ item.event.availablebusy }} - {{ item.type }}
                            </p>
                            <p class="dim-text mb-2">
                              <i class="pi pi-calendar-times f-12 mr-1"></i>
                              {{ item.event.start.dateTime | wallClock | date: 'd MMM yy' }}
                              {{ getTimeFormat(item.event.start.dateTime) }} -
                              {{ getTimeFormat(item.event.end.dateTime) }}
                            </p>
                            <p class="dim-text" *ngIf="item?.event?.location">
                              <i class="pi pi-map-marker f-12 mr-1"></i>
                              {{ item.event.location }}
                            </p>
                          </div>
                        </ng-container>
                        <div style="text-align: center">
                          <p-button *ngIf="appointmentPageSize <= property_apt_list?.length" (click)="appointmentPageSize = appointmentPageSize + 5">
                            See more
                          </p-button>
                        </div>
                      </div>
                    </app-collapse-box>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!selectedProperty?.agent">
                <div class="d-flex align-items-center">
                  <img [src]="common_images?.stream_new" class="email-connect mr-4" />
                  <p class="f-12">Please select and connect Listing Agent</p>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-template #listingNotApp>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
        <div
          id="Tasks"
          role="tabpanel"
          aria-labelledby="pills-Tasks-tab"
          tabindex="0"
          class="tab-pane listing-pane fade {{ activeIndexs === 4 && 'show active' }}">
          <div class="ld-card__head">
            <div>
              <p class="ld-card__title"><i class="ld-card__icon pi pi-check-square"></i>Tasks</p>
              <p class="ld-card__note">Work scheduled against this listing.</p>
            </div>
            <button class="_outline-btn" *ngxPermissionsOnly="['task.create']" (click)="addNewTask(null, true)">
              <i class="pi pi-plus mr-2 f-12"></i>New Task
            </button>
          </div>
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotTask">
            <ng-container>
              <div>
                <div>
                  <ng-container *ngIf="fullList?.length > 0">
                    <div class="position-relative">
                      <div
                        class="s-custom-entity-records scrol_ mob-table"
                        style="max-height: 500px"
                        (scroll)="onSideTaskScroll($event)"
                        #sideTaskScrollableElement>
                        <i class="pi pi-arrow-up" (click)="sideTaskScrollToTop()" *ngIf="sideTaskScrollTop > 50"></i>
                        <p-table
                          id="customentitydatalist"
                          [value]="fullList"
                          [columns]="columns"
                          dataKey="_id"
                          [rowHover]="false"
                          [rows]="sideTaskRows"
                          (sortFunction)="lmService.customSort($event)"
                          [customSort]="true"
                          scrollWidth="100%">
                          <ng-template pTemplate="header">
                            <tr class="no-wrap">
                              <!-- <th style="width:3rem;"></th> -->
                              <ng-container *ngFor="let col of columns">
                                <th class="f-12 pl-0" *ngIf="col.column != '_id'" [pSortableColumn]="col.field">
                                  <div class="ml-2 p-d-flex p-ai-center">
                                    {{ col.column }}
                                    <p-sortIcon [field]="col.field" class="ml-auto"></p-sortIcon>
                                  </div>
                                </th>
                              </ng-container>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-task let-columns="columns">
                            <tr>
                              <ng-container *ngFor="let col of columns">
                                <td style="cursor: pointer" (click)="addNewTask(task, false)" class="pl-2">
                                  <p class="f-12">
                                    <ng-container *ngIf="col.field !== 'start_date' && col.field !== 'due_date'">
                                      {{ task[col.field] }}
                                    </ng-container>
                                    <ng-container *ngIf="col.field === 'start_date' || col.field === 'due_date'">
                                      {{ task[col.field] | date: 'dd/MM/yy' }}
                                    </ng-container>
                                  </p>
                                </td>
                              </ng-container>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="5">No record found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                    <p class="legal-records">{{ 'Records: ' + fullList?.length }}</p>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #listingNotTask>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
        <div
          id="Related"
          role="tabpanel"
          aria-labelledby="pills-Related-tab"
          tabindex="0"
          class="tab-pane fade {{ activeIndexs === 5 && 'show active' }}">
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotRelated">
            <div class="ld-card">
              <div class="ld-card__head">
                <div>
                  <p class="ld-card__title"><i class="ld-card__icon pi pi-users"></i>Related Contacts</p>
                  <p class="ld-card__note">Add and manage people related to this listing.</p>
                </div>
                <!-- <button class="_primary-btn btn-sm" (click)="openRightModal(null, 'add_contact')">
                  <i class="pi pi-plus mr-1 f-12"></i>
                  Add Contact
                </button> -->
              </div>

              <div class="rel-picker">
                <div class="rel-picker__hint" *ngIf="!attached_contacts?.length">
                  <img [src]="images?.related_contact" width="35" />
                  <p class="f-12 ml-3 mb-0">Search and add contacts to this listing.</p>
                </div>
                <div class="rel-picker__field p-autocomplete-70">
                  <re-multiselect
                    [module]="'contacts'"
                    [placeholder]="'Select'"
                    [truncate]="25"
                    [isMultiple]="false"
                    [isCreateNew]="true"
                    [isClear]="true"
                    [isEmail]="true"
                    (createNew)="openRightModal(null, 'add_contact')"
                    [selected_ids]="selectedRelatedContact"
                    (onUpdate)="contactSelection($event)"
                    [style]="{ width: '100%' }"></re-multiselect>
                </div>
                <button class="_outline-btn" (click)="attachContact()" [class.disabled]="isAssociateDisable">Associate</button>
              </div>

              <!-- The chips are drag sources for the table's Contact Type cells, so they stay inside
                   the same drop-list group as the table. -->
              <div class="contact-tags mob-table" *ngIf="attached_contacts?.length" cdkDropListGroup>
                <p class="ld-field__label">Contact Type</p>
                <div
                  class="d-flex align-items-center flex-wrap"
                  *ngIf="listingService.listingPropertyOption.contactType"
                  cdkDropList
                  [cdkDropListConnectedTo]="getConnectedTo()">
                  <ng-container *ngFor="let tag of listingService.listingPropertyOption.contactType">
                    <span class="related-tag" *ngIf="tag?.tag_name !== 'Owner'" cdkDrag [cdkDragData]="tag.tag_name">
                      <span class="p-tag-value">{{ tag.tag_name }}</span>
                    </span>
                  </ng-container>
                </div>
                <p class="ld-field__label mt-3">Relationship</p>
                <div
                  class="mb-3 d-flex align-items-center flex-wrap"
                  *ngIf="listingService.listingPropertyOption.relatedContactTags"
                  cdkDropList
                  [cdkDropListConnectedTo]="getConnectedTo()">
                  <span
                    class="related-tag"
                    *ngFor="let tag of listingService.listingPropertyOption.relatedContactTags"
                    cdkDrag
                    [cdkDragData]="tag.tag_name">
                    <span class="p-tag-value">{{ tag.tag_name }}</span>
                  </span>
                </div>
                <div class="position-relative">
                  <div
                    class="s-custom-entity-records scrol_ mob-table related_contact"
                    style="max-height: 400px"
                    (scroll)="onRelContactScroll($event)"
                    #relContactScrollableElement>
                    <i class="pi pi-arrow-up" (click)="relContactScrollToTop()" *ngIf="relContactScrollTop > 50"></i>
                    <p-table
                      id="customentitydatalist"
                      [value]="attached_contacts"
                      [columns]="ContactColumns"
                      dataKey="_id"
                      [rowHover]="false"
                      [rows]="relContactRows"
                      (sortFunction)="lmService.customSort($event)"
                      [customSort]="true"
                      [resizableColumns]="true"
                      [autoLayout]="true">
                      <ng-template pTemplate="header">
                        <tr>
                          <th style="width: 4rem !important" class="text-center"></th>
                          <ng-container *ngFor="let col of ContactColumns">
                            <th class="f-12" *ngIf="col.column != '_id'" [pSortableColumn]="col.field">
                              <div class="d-flex align-items-center">
                                {{ col.column }}
                                <p-sortIcon field="{{ col.field }}" (click)="sortData(col.field)" class="ml-auto"></p-sortIcon>
                              </div>
                            </th>
                          </ng-container>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-task let-columns="columns">
                        <tr class="cp">
                          <td style="width: 4rem">
                            <img [src]="common_images?.delete_theme" alt="delete" width="16px" (click)="deleteAttachedContact(task._id)" />
                          </td>
                          <ng-container *ngFor="let col of ContactColumns">
                            <td
                              cdkDropList
                              [id]="'s_' + task?._id"
                              *ngIf="col.field === 'contact_type'"
                              [cdkDropListData]="task['type']"
                              (cdkDropListDropped)="drop($event, task)"
                              style="width: auto; padding-left: 12px !important">
                              <ng-container *ngFor="let tag of task['type']">
                                <p-chip styleClass="mr-2 f-10" [label]="tag" [removable]="true" (onRemove)="removeTag(tag, task)"> </p-chip>
                              </ng-container>
                            </td>
                            <td
                              style="width: auto; cursor: pointer; padding-left: 12px !important"
                              *ngIf="col.field !== 'contact_type'"
                              (click)="openRightModal(task, 'edit_contact')">
                              <p class="f-12 pl-1">
                                <ng-container *ngIf="col.field !== 'address' && col.field !== 'full_name'">
                                  {{ task['contact'][col.field] }}
                                </ng-container>
                                <ng-container *ngIf="col.field === 'address'">
                                  {{ task['contact']['property_address'] }}
                                </ng-container>
                                <ng-container *ngIf="col.field === 'full_name'">
                                  {{ task['contact']['full_name'] }}
                                </ng-container>
                              </p>
                            </td>
                          </ng-container>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="4">No record found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <p class="legal-records" *ngIf="attached_contacts?.length > 0">{{ 'Records: ' + attached_contacts?.length }}</p>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #listingNotRelated>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
        <div
          id="approval"
          role="tabpanel"
          aria-labelledby="pills-approval-tab"
          tabindex="0"
          class="tab-pane listing-pane fade position-relative {{ activeIndexs === 6 && 'show active' }} mob-table">
          <div class="ld-card__head">
            <div>
              <p class="ld-card__title"><i class="ld-card__icon pi pi-verified"></i>Approval</p>
              <p class="ld-card__note">Send this listing for approval and track its comments.</p>
            </div>
          </div>
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotApproval">
            <div class="publish_date {{ mobToggle ? 'my-3' : '' }}">
              <p *ngIf="publish_date" class="mr-2 f-10" [ngClass]="{ published_color: publish_date?.toString()?.includes('Published') }">
                {{ publish_date }}
              </p>
              <button class="_outline-btn btn-sm bg-white" (click)="approvel.toggle($event)">
                {{ approval_btn_text ? approval_btn_text : 'Send Approval' }}
              </button>
            </div>
            <div>
              <p-overlayPanel #approvel [dismissable]="true" [showCloseIcon]="true" appendTo="body">
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <p-radioButton
                      name="send"
                      value="send"
                      [(ngModel)]="sendRemainder"
                      [ngModelOptions]="{ standalone: true }"
                      inputId="sendOption"></p-radioButton>
                    <p class="all-item pt-2 pb-2 pl-2 pr-3" for="sendOption">Send</p>
                  </div>
                  <div class="d-flex">
                    <p-radioButton
                      name="send"
                      value="send remainder"
                      [(ngModel)]="sendRemainder"
                      [ngModelOptions]="{ standalone: true }"
                      inputId="sendRemainderOption"></p-radioButton>
                    <p class="all-item pt-2 pb-2 pl-2 pr-3" for="sendRemainderOption">Send with Reminders</p>
                  </div>
                </div>
                <ng-container *ngIf="sendRemainder === 'send remainder'">
                  <div class="col-sm-12 mt-3">
                    <ng-select
                      [(ngModel)]="remainder"
                      [ngModelOptions]="{ standalone: true }"
                      [items]="reminder_options"
                      [searchable]="true"
                      placeholder="Select Remainder"
                      class="_select">
                    </ng-select>
                  </div>
                </ng-container>
                <button class="_outline-btn mt-3" (click)="sendApproval(); approvel.hide()" [disabled]="loading">Save</button>
              </p-overlayPanel>
            </div>
            <div class="d-flex align-items-center secondary-tabs b-b-tabs">
              <ul class="listing-model-tabs nav tools-tab-nav w-100 align-items-end bor-bottom" role="tablist">
                <li class="nav-item cursor-pointer pr-0" role="presentation">
                  <a
                    class="active"
                    id="pills-comment-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#comment"
                    role="tab"
                    aria-controls="comment"
                    aria-selected="true"
                    ><img [src]="images?.comments_icon" alt="comments" class="mr-2" />Comments</a
                  >
                </li>
                <li class="nav-item cursor-pointer pl-0" role="presentation" (click)="getApprovalHistory()">
                  <a
                    class=""
                    id="pills-history-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#history"
                    role="tab"
                    aria-controls="history"
                    aria-selected="false"
                    ><img [src]="images?.listing_history" alt="history" class="mr-2" />History</a
                  >
                </li>
              </ul>
            </div>
            <div class="tab-content">
              <div id="comment" role="tabpanel" aria-labelledby="pills-comment-tab" tabindex="0" class="tab-pane fade show active">
                <div class="mt-2">
                  <app-approvel-comments
                    [showUserComments]="true"
                    [comments]="listingComments"
                    [readWritePermissions]="readWritePermissions"
                    [lisitngDetail]="selectedProperty"
                    [inOneline]="true"
                    [cb_afterupdate]="onUpdateCallBack.bind(this)"></app-approvel-comments>
                </div>
              </div>
              <div id="history" role="tabpanel" aria-labelledby="pills-history-tab" tabindex="0" class="tab-pane fade">
                <div class="mt-2">
                  <div>
                    <div class="filter-by-tasks">
                      <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input
                          class="_input-icon"
                          [(ngModel)]="history_keyword"
                          type="text"
                          id="history_input"
                          (input)="getApprovalHistory(this.selectedProperty)"
                          placeholder="Search by keyword" />
                      </span>
                    </div>
                  </div>
                  <div class="mt-2 w-100 historytbl">
                    <div class="position-relative">
                      <div class="s-custom-entity-records scrol_ mob-table" (scroll)="onAprHistoryScroll($event)" #aprHistoryScrollableElement>
                        <i class="pi pi-arrow-up" (click)="aprHistoryScrollToTop()" *ngIf="aprHistoryScrollTop > 50"></i>
                        <p-table
                          id="customentitydatalist"
                          [autoLayout]="true"
                          [value]="approvalHistoryList"
                          styleClass="history-table"
                          dataKey="_id"
                          [rowHover]="false"
                          [tableStyle]="{ 'min-width': '45rem' }">
                          <ng-template pTemplate="header" let-columns>
                            <tr class="no-wrap">
                              <th pSortableColumn="created_at" style="width: 150px">
                                Changed Date
                                <p-sortIcon class="ml-2" field="created_at" st></p-sortIcon>
                              </th>
                              <th pSortableColumn="user_name">
                                Changed By
                                <p-sortIcon class="ml-2" field="user_name" st></p-sortIcon>
                              </th>
                              <th pSortableColumn="event" style="width: 70px">
                                Event
                                <p-sortIcon class="ml-2" field="event" st></p-sortIcon>
                              </th>
                              <th pSortableColumn="Comments">
                                Comments
                                <p-sortIcon class="ml-2" field="Comments" st></p-sortIcon>
                              </th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-history let-columns="columns">
                            <tr>
                              <td>{{ history?.created_at | date: 'dd-MM-YYYY hh:mm a' }}</td>
                              <td>{{ history?.user_name }}</td>
                              <td>{{ history?.event }}</td>
                              <ng-container *ngIf="history?.event === 'Approved'; else notApproved">
                                <td>Activated on: {{ history?.Comments | date: 'dd/mm/yyyy' }}</td>
                              </ng-container>
                              <ng-template #notApproved>
                                <td><span [innerHTML]="history?.Comments"></span></td>
                              </ng-template>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="5">No record found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                    <div class="mt-2">
                      <p *ngIf="approvalHistoryList?.length > 0">
                        {{ 'Records: ' + approvalHistoryPagination?.total }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #listingNotApproval>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
        <div
          id="Commission"
          role="tabpanel"
          aria-labelledby="pills-Commission-tab"
          tabindex="0"
          class="tab-pane listing-pane fade {{ activeIndexs === 7 && 'show active' }}">
          <div class="ld-card__head">
            <div>
              <p class="ld-card__title"><i class="ld-card__icon pi pi-percentage"></i>Commission</p>
              <p class="ld-card__note">Commission agreed for this listing.</p>
            </div>
          </div>
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotCommission">
            <ng-container *ngIf="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager'; else noAdmin">
              <p class="_fw-600 mb-3">Please select agent commission type</p>
              <div class="mt-2 col-sm-12 {{ mobToggle ? 'd-block' : 'd-flex' }} align-items-center">
                <div class="col-sm-3 pr-2 p-field-radiobutton d-flex align-items-center">
                  <p-radioButton
                    name="sale_type"
                    value="default_commission"
                    [(ngModel)]="commission_applied"
                    (onClick)="overRide()"
                    [disabled]="
                      userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true
                    "></p-radioButton>
                  <p>Default Commission</p>
                </div>
                <div class="col-sm-3 p-field-radiobutton d-flex align-items-center {{ mobToggle ? 'my-2' : '' }}">
                  <p-radioButton
                    name="sale_type"
                    value="agent_commission"
                    [(ngModel)]="commission_applied"
                    (onClick)="overRide()"
                    [disabled]="
                      userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true
                    "></p-radioButton>
                  <p>Agent Commission</p>
                </div>
              </div>
              <div class="d-flex align-items-center my-3" *ngIf="commission_applied">
                <p>Apply Commission</p>
                <div class="switch-button ml-5">
                  <button
                    class="{{ isPercentage == true ? 'button-active-class' : 'button-non-class' }}"
                    (click)="isPercentage = !isPercentage"
                    [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                    %
                  </button>
                  <button
                    class="{{ isPercentage == false ? 'button-active-class' : 'button-non-class' }}"
                    (click)="isPercentage = !isPercentage"
                    [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                    $
                  </button>
                </div>
              </div>
              <div class="d-flex">
                <div class="position-relative" *ngIf="isPercentage == true">
                  <p class="mb-2">Commission Rate (%)</p>
                  <input
                    type="number"
                    [min]="0"
                    class="_input w-100x"
                    [(ngModel)]="commission_rate"
                    [readonly]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true" />
                  <i class="percent-icon">%</i>
                </div>
                <div *ngIf="isPercentage == false">
                  <p class="mb-2">Commission Amount ($)</p>
                  <div class="w-100x">
                    <app-price-input
                      [field_value]="commission_amount"
                      [isReadOnly]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true"
                      (onUpdate)="updatePrice($event, 'commission_amount')">
                    </app-price-input>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="tiered_commission?.length > 0">
                <p class="_fw-600 my-3 f-14">Tiered Commission Rate</p>
                <div class="d-flex mb-2" *ngFor="let itm of tiered_commission; let ind = index">
                  <div class="switch-button mt-22 mr-2">
                    <button
                      class="{{ itm.isPercentage == true ? 'button-active-class' : 'button-non-class' }}"
                      (click)="itm.isPercentage = !itm.isPercentage"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                      %
                    </button>
                    <button
                      class="{{ itm.isPercentage == false ? 'button-active-class' : 'button-non-class' }}"
                      (click)="itm.isPercentage = !itm.isPercentage"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                      $
                    </button>
                  </div>
                  <div>
                    <p class="mb-2">Upto</p>
                    <input
                      type="number"
                      [min]="0"
                      class="_input w-100x"
                      [(ngModel)]="itm.up_to"
                      [ngModelOptions]="{ standalone: true }"
                      [readonly]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true" />
                  </div>
                  <div class="ml-2 position-relative" *ngIf="itm.isPercentage == true">
                    <p class="mb-2">Commission Rate (%)</p>
                    <input
                      type="number"
                      [min]="0"
                      class="_input w-100x"
                      [(ngModel)]="itm.commission_rate"
                      [ngModelOptions]="{ standalone: true }"
                      [readonly]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true" />
                    <i class="percent-icon">%</i>
                  </div>
                  <div class="ml-2" *ngIf="itm.isPercentage == false">
                    <p class="mb-2">Commission Amount ($)</p>
                    <div class="w-100x">
                      <app-price-input
                        [field_value]="itm.commission_amount"
                        [isReadOnly]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true"
                        (onUpdate)="updatePrice($event, 'tiered_commission_amount', ind)">
                      </app-price-input>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="specific_commission?.length > 0">
                <p class="_fw-600 f-14 my-3">Apply overrides for specific users, listings, or projects</p>
                <div class="d-flex mb-2" *ngFor="let itm of specific_commission; let ind = index">
                  <div class="switch-button mt-22 mr-2">
                    <button
                      class="{{ itm.isPercentage == true ? 'button-active-class' : 'button-non-class' }}"
                      (click)="itm.isPercentage = !itm.isPercentage"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                      %
                    </button>
                    <button
                      class="{{ itm.isPercentage == false ? 'button-active-class' : 'button-non-class' }}"
                      (click)="itm.isPercentage = !itm.isPercentage"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                      $
                    </button>
                  </div>
                  <div class="w-200">
                    <p class="mb-2">User</p>
                    <ng-select
                      [items]="originalAssigns"
                      bindLabel="full_name"
                      bindValue="_id"
                      [searchable]="true"
                      [clearable]="true"
                      [(ngModel)]="itm.user_commission"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Select"
                      class="_select"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                      <ng-template ng-option-tmp let-item="item">
                        <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item">
                        <p>{{ item.full_name }}</p>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="w-200 mx-2">
                    <p class="mb-2">Listing / Project</p>
                    <ng-select
                      [items]="commission_category"
                      bindLabel="name"
                      bindValue="value"
                      [searchable]="true"
                      [clearable]="false"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true"
                      [(ngModel)]="itm.commission_category"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Select"
                      class="_select"
                      (change)="showCateBase(itm.commission_category, ind)">
                    </ng-select>
                  </div>
                  <div class="w-300 mr-2" *ngIf="itm.commission_category == 'listing'">
                    <p class="mb-2">Listing</p>
                    <ng-select
                      [items]="lmService?.properties"
                      bindLabel="property_address"
                      bindValue="_id"
                      [searchable]="true"
                      [clearable]="true"
                      [(ngModel)]="itm.listing"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Select"
                      class="_select"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                    </ng-select>
                  </div>
                  <div class="w-300 mr-2" *ngIf="itm.commission_category == 'project'">
                    <p class="mb-2">Project</p>
                    <ng-select
                      [items]="lmService?.ProjectList"
                      bindLabel="Project_Name"
                      bindValue="_id"
                      [searchable]="true"
                      [clearable]="true"
                      [(ngModel)]="itm.project"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Select"
                      class="_select"
                      [disabled]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true">
                    </ng-select>
                  </div>
                  <div class="position-relative" *ngIf="itm.isPercentage == true">
                    <p class="mb-2">Commission Rate (%)</p>
                    <input
                      type="number"
                      [min]="0"
                      class="_input w-100x"
                      [(ngModel)]="itm.commission_rate"
                      [ngModelOptions]="{ standalone: true }"
                      [readonly]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true" />
                    <i class="percent-icon">%</i>
                  </div>
                  <div *ngIf="itm.isPercentage == false">
                    <p class="mb-2">Commission Amount ($)</p>
                    <div class="w-100x">
                      <app-price-input
                        [field_value]="itm.commission_amount"
                        [isReadOnly]="userRole == 'administrators' || userRole == 'master admin' || userRole == 'operations manager' ? false : true"
                        (onUpdate)="updatePrice($event, 'specific_commission_amount', ind)">
                      </app-price-input>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #noAdmin>
              <div class="s-custom-entity-records scrol_">
                <p-table
                  id="customentitydatalist"
                  [autoLayout]="true"
                  [value]="commission_list"
                  [rowHover]="false"
                  [tableStyle]="{ 'min-width': 'auto' }"
                  scrollWidth="100%">
                  <ng-template pTemplate="header">
                    <tr class="no-wrap">
                      <th class="pl-0" style="min-width: 110px; width: 110px">Contract Price</th>
                      <th class="pl-0" style="min-width: 110px; width: 110px">Contract Status</th>
                      <th class="pl-0" style="min-width: 110px; width: 110px">Settlement Date</th>
                      <th class="pl-0" style="min-width: 130px; width: 130px">Commission (%) / ($)</th>
                      <th class="pl-0" style="min-width: 140px; width: 140px">Commission Amount</th>
                      <th class="pl-0" style="min-width: 140px; width: 140px">Commission Status</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" let-expanded="expanded">
                    <tr>
                      <td class="pl-3">
                        <p>{{ rowData?.contractPrice | currency: 'USD' : true : '1.0-0' }}</p>
                      </td>
                      <td class="pl-3">
                        <p>{{ rowData?.contractStatus }}</p>
                      </td>
                      <td class="pl-3">
                        <p>{{ rowData?.settlement | date: 'dd/MM/yy' }}</p>
                      </td>
                      <td class="pl-3">
                        <p>
                          {{
                            rowData?.isPercentage == true ? rowData?.commission_rate : (rowData?.commission_amount | currency: 'USD' : true : '1.0-0')
                          }}
                        </p>
                      </td>
                      <td class="pl-3">
                        <p>
                          {{
                            rowData?.isPercentage == true
                              ? valueCopy(rowData?.commission_amount)
                              : (rowData?.commission_amount | currency: 'USD' : true : '1.0-0')
                          }}
                        </p>
                      </td>
                      <td class="pl-3">
                        <p>{{ rowData?.contractStatus !== 'Settled' ? 'Upcoming' : '' }}</p>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr class="border-0">
                      <td colspan="6">{{ 'No commissions available' }}</td>
                    </tr>
                  </ng-template>
                </p-table>
                <div class="mt-5">
                  <p *ngIf="commission_list?.length > 0">
                    {{ 'Records: ' + commission_list?.length }}
                  </p>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #listingNotCommission>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
        <div
          id="Conjunction"
          role="tabpanel"
          aria-labelledby="pills-Conjunction-tab"
          tabindex="0"
          class="tab-pane fade {{ activeIndexs === 8 && 'show active' }}">
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotConjuction">
            <div class="ld-card">
              <div class="ld-card__head">
                <div>
                  <p class="ld-card__title"><i class="ld-card__icon pi pi-percentage"></i>Conjunction</p>
                  <p class="ld-card__note">Set the sales commission and add any conjunction details for this listing.</p>
                </div>
              </div>
              <div class="ld-field conj-commission">
                <p class="ld-field__label">Sales Commission</p>
                <div class="position-relative">
                  <input class="_input" [(ngModel)]="saleCommission" type="number" />
                  <i *ngIf="saleCommission" class="percent-icon">%</i>
                </div>
              </div>
              <div class="ld-field mb-0">
                <p class="ld-field__label">Conjunction Details</p>
                <div class="_paragraph">
                  <ckeditor [(ngModel)]="conjunctionDetails" [editor]="Editor" (ready)="onReadyDes($event)"> </ckeditor>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #listingNotConjuction>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>

        <div
          id="notes"
          role="tabpanel"
          aria-labelledby="pills-notes-tab"
          tabindex="0"
          class="tab-pane listing-pane fade"
          [class.show]="activeIndexs === 9"
          [class.active]="activeIndexs === 9">
          <div class="ld-card__head">
            <div>
              <p class="ld-card__title"><i class="ld-card__icon pi pi-book"></i>Notes</p>
              <p class="ld-card__note">Notes kept against this listing.</p>
            </div>
          </div>
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotNote">
            <div *ngIf="activeIndexs === 9" class="listing-notes related_contact  {{ mobToggle && 'w-240px' }}">
              <app-notes
                [isListing]="true"
                [moduleId]="
                  this.selectedProperty || {
                    _id: this.insertedPropertyId,
                    property_address: editProperty.controls['property_address'].value,
                  }
                "></app-notes>
            </div>
          </ng-container>
          <ng-template #listingNotNote>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
        <div
          id="History"
          role="tabpanel"
          aria-labelledby="pills-History-tab"
          tabindex="0"
          class="tab-pane listing-pane fade {{ activeIndexs === 10 && 'show active' }}">
          <div class="ld-card__head">
            <div>
              <p class="ld-card__title"><i class="ld-card__icon pi pi-history"></i>History</p>
              <p class="ld-card__note">Every change made to this listing.</p>
            </div>
          </div>
          <ng-container *ngIf="property_id || insertedPropertyId; else listingNotHistory">
            <ng-container *ngIf="activeIndexs === 10">
              <app-remmi-history [module]="'Property'" [record_id]="property_id || insertedPropertyId"></app-remmi-history>
            </ng-container>
          </ng-container>
          <ng-template #listingNotHistory>
            <ng-container *ngTemplateOutlet="listingNotCreated"></ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #calendarAppointment>
  <p-dialog
    [(visible)]="addNewApt"
    [position]="'center'"
    [styleClass]="'noHeader'"
    [showHeader]="false"
    [style]="mobToggle ? { width: '100%' } : { width: '650px' }">
    <div class="headerIcon d-flex justify-content-end">
      <div class="crossiconStyle cursor-pointer event_poup_close_btn" (click)="cancelAppointment()">
        <img [src]="common_images?.close_icon" class="p-1" width="30px" (click)="resetForm()" />
      </div>
    </div>
    <div class="row ml-0 mr-0 mt-2">
      <div class="col-md-12 p-0">
        <input type="text" [(ngModel)]="aptEventTitle" placeholder="Add title" />
        <div class="d-flex b-y-light w-100">
          <div class="w-65px" style="margin-top: 37px">
            <img [src]="common_images?.email_overview_icon" class="img-20 mr-1" />
          </div>
          <div class="py-3 content-inputs">
            <div class="row align-items-center">
              <div class="col-sm-3">
                <p class="mb-1">Start Date</p>
                <p-calendar
                  [(ngModel)]="insertEvent.startdate"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  inputId="basic"
                  placeholder="DD-MM-YY"
                  class="mr-2"
                  [readonlyInput]="true"></p-calendar>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="row">
                  <p class="mb-1">Start Time</p>
                  <div class="col-sm-4 {{ mobToggle ? 'my-2' : '' }}">
                    <ng-select
                      [(ngModel)]="selectedStartHour"
                      [items]="hours"
                      placeholder="Hr"
                      [clearable]="false"
                      (change)="startHourChange()"
                      class="_select">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0 {{ mobToggle ? 'my-2' : '' }}">
                    <ng-select
                      [(ngModel)]="selectedStartMinutes"
                      [items]="minutes"
                      placeholder="Min"
                      [clearable]="false"
                      (change)="startMinuteChange()"
                      class="_select">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0 {{ mobToggle ? 'my-2' : '' }}">
                    <ng-select
                      [(ngModel)]="selectedStartDuration"
                      [items]="duration"
                      placeholder="Min"
                      [clearable]="false"
                      (change)="startHourChange()"
                      class="_select">
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="row">
                  <p class="mb-1">End Time</p>
                  <div class="col-sm-4 pl-0 {{ mobToggle ? 'my-2' : '' }}">
                    <ng-select
                      [(ngModel)]="selectedEndHour"
                      [items]="hours"
                      placeholder="Hr"
                      [clearable]="false"
                      (change)="endHourChange()"
                      class="_select">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0 {{ mobToggle ? 'my-2' : '' }}">
                    <ng-select
                      [(ngModel)]="selectedEndMinutes"
                      [items]="minutes"
                      placeholder="Min"
                      [clearable]="false"
                      (change)="endMinuteChange()"
                      class="_select">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0 {{ mobToggle ? 'my-2' : '' }}">
                    <ng-select
                      [(ngModel)]="selectedEndDuration"
                      [items]="duration"
                      placeholder="Min"
                      [clearable]="false"
                      (change)="endHourChange()"
                      class="_select">
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex mb-3">
          <div class="w-65px pt-2">
            <i class="pi pi-map-marker text-light f-18"></i>
          </div>
          <div class="content-inputs position-relative">
            <input
              appendTo="body"
              class="_input-icon"
              placeholder="Location"
              google-places-autocomplete
              [options]="options"
              [(ngModel)]="insertEvent.location"
              autocomplete="off" />
            <i class="pi pi-search _search-icon"></i>
          </div>
        </div>
        <div class="d-flex mb-3">
          <div class="w-65px pt-3">
            <img [src]="common_images?.email_user_icon" class="img-20 mr-1" />
          </div>
          <div class="col-md-11 listing-appointment calendar-contact">
            <p>Add email and press enter to invite</p>
            <ng-select
              [items]="originalAssignsAppt"
              [(ngModel)]="insertEvent.agent"
              [multiple]="true"
              [searchable]="true"
              bindLabel="full_name"
              bindValue="_id"
              placeholder="Select Agent"
              [addTag]="addCustomAgent"
              (add)="added_appt_agent()">
              <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <i class="ng-value-icon pi pi-times-circle" (click)="clear(item?._id, 'appt_agent')"></i>
                  <p class="ng-value-label">{{ item?.full_name }}</p>
                </div>
              </ng-template>
            </ng-select>
            <span class="dummy-text" *ngIf="showErrorForExternalAgent == true">
              <p class="form-error">Please add an office user with a connected calendar to send the calendar invite.</p>
            </span>
          </div>
        </div>

        <div class="b-y-light w-100">
          <div class="w-100">
            <div class="d-flex">
              <div class="w-65px py-4">
                <img [src]="common_images?.eye_icon" class="img-20 mr-1" />
              </div>
              <div class="py-3 content-inputs">
                <div class="d-flex align-items-center">
                  <div class="w-170px">
                    <ng-select
                      class="text-captilize"
                      [items]="availablebusy"
                      [(ngModel)]="insertEvent.availablebusy"
                      bindLabel="name"
                      bindValue="name"
                      [searchable]="true"
                      [multiple]="false"
                      placeholder="Busy"
                      class="_select">
                    </ng-select>
                  </div>
                  <div class="w-170px ml-1">
                    <ng-select
                      class="text-captilize"
                      [items]="available"
                      [(ngModel)]="insertEvent.availability"
                      bindLabel="name"
                      bindValue="name"
                      [searchable]="true"
                      [multiple]="false"
                      placeholder="Availability"
                      class="_select">
                    </ng-select>
                  </div>
                  <i class="pi pi-info-circle text-light ml-1 f-18"></i>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <i class="pi pi-book w-65px text-light"></i>
              <div class="_paragraph content-inputs w-100">
                <ckeditor class="c-editor" [(ngModel)]="insertEvent.description" data="" [editor]="Editor"> </ckeditor>
              </div>
            </div>
            <div class="flexCenterEnd mt-3">
              <button class="_cancel-btn mr-2" (click)="cancelAppointment()">Cancel</button>
              <button (click)="insertEventAppointment()" [class.disabled]="event_loading" class="_primary-btn">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-template>

<ng-template #listingNotCreated>
  <p class="mt-2">Please create the listing before accessing the tab</p>
</ng-template>

<!-- The detail panel owns these tabs, but it is hidden while the Leads page runs full-page —
     so the strip above that page renders the same list and they stay reachable. -->
<ng-template #listingDetailTabs>
  <li class="nav-item cursor-pointer" role="presentation" (click)="openListingTab(5)">
    <a
      [class.active]="activeIndex === 5"
      id="pills-dashboard-tab"
      data-bs-toggle="pill"
      data-bs-target="#dashboard"
      role="tab"
      aria-controls="dashboard"
      aria-selected="false">
      <i class="pi pi-th-large f-14 mr-1"></i>
      Dashboard
    </a>
  </li>
  <li class="nav-item cursor-pointer" role="presentation" (click)="openListingTab(0)">
    <a
      [class.active]="activeIndex === 0"
      id="pills-listDetails-tab"
      data-bs-toggle="pill"
      data-bs-target="#listDetails"
      role="tab"
      aria-controls="listDetails"
      aria-selected="false">
      <img [src]="common_images?.home" alt="gavel" class="mr-1 mb-1" width="18px" height="18px" />
      Listing
    </a>
  </li>
  <li class="nav-item cursor-pointer" role="presentation" (click)="openListingTab(1); isImg = true; isDocuments = false">
    <a
      [class.active]="activeIndex === 1"
      id="pills-img-tab"
      data-bs-toggle="pill"
      data-bs-target="#img"
      role="tab"
      aria-controls="img"
      aria-selected="false"
      ><img [src]="common_images?.light_img_icon" alt="gavel" class="mr-1 mb-1" width="18px" height="18px" /> Images</a
    >
  </li>
  <li class="nav-item cursor-pointer" role="presentation" (click)="openListingTab(2); fetchApts(selectedProperty)">
    <a
      [class.active]="activeIndex === 2"
      id="pills-inspection-tab"
      data-bs-toggle="pill"
      data-bs-target="#inspection"
      role="tab"
      aria-controls="inspection"
      aria-selected="false">
      <img [src]="images?.eye_icon" alt="gavel" class="mr-1 mb-1" width="18px" height="18px" />Inspections</a
    >
  </li>
  <li
    class="nav-item cursor-pointer"
    role="presentation"
    (click)="openListingTab(3); solicitorContact(); getContractAccordingProperty()"
    *ngFlag="'contracts'">
    <a
      [class.active]="activeIndex === 3"
      id="pills-legal-tab"
      data-bs-toggle="pill"
      data-bs-target="#legal"
      role="tab"
      aria-controls="legal"
      aria-selected="false">
      <img [src]="common_images?.gavel_icon" alt="gavel" class="mr-1 mb-1" width="18px" height="18px" />
      Legal
      <ng-container *ngIf="activeContract?.length > 0; else pendingCont">
        <p class="ml-2 a-head-badge">{{ activeContract?.length }}</p>
      </ng-container>
      <ng-template #pendingCont>
        <p class="ml-2 p-head-badge">{{ pendingContract?.length }}</p>
      </ng-template>
    </a>
  </li>
  <li class="nav-item cursor-pointer" role="presentation" (click)="openListingTab(4); isImg = false; isDocuments = true">
    <a
      [class.active]="activeIndex === 4"
      id="pills-document-tab"
      data-bs-toggle="pill"
      data-bs-target="#document"
      role="tab"
      aria-controls="document"
      aria-selected="false">
      <img [src]="images?.document_icon" alt="gavel" class="mr-1 mb-1" width="18px" height="18px" />Files</a
    >
  </li>
  <li class="nav-item cursor-pointer" role="presentation" (click)="openListingTab(6); getDomainEmail()" *ngxPermissionsOnly="['listing_portal.view']">
    <a
      [class.active]="activeIndex === 6"
      id="pills-portal-tab"
      data-bs-toggle="pill"
      data-bs-target="#portal"
      role="tab"
      aria-controls="portal"
      aria-selected="false">
      <img [src]="images?.laptop_icon" alt="gavel" class="mr-1 mb-1" width="18px" height="18px" />
      Portals
      <p class="ml-2 p-head-badge" *ngIf="trueCount">{{ trueCount }}</p>
    </a>
  </li>
</ng-template>

<!-- The drawer's second strip used to live in its own splitter panel. Both strips are one row
     now, so these sit beside the detail tabs in the single list above the content. -->
<ng-template #listingWorkTabs>
  <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'lead'">
    <a
      class=""
      id="pills-Lead-tab"
      data-bs-toggle="pill"
      data-bs-target="#Lead"
      role="tab"
      (click)="openWorkTab(1)"
      aria-controls="Lead"
      aria-selected="false"
      [class.active]="activeIndexs === 1">
      <img [src]="images?.listing_lead_icon" alt="lead" width="16px" height="16px" class="mr-1" />
      Leads
    </a>
  </li>
  <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'calendar'">
    <a
      class=""
      id="pills-Appointments-tab"
      data-bs-toggle="pill"
      data-bs-target="#Appointments"
      role="tab"
      (click)="openWorkTab(2); isCache = false; calendarAccessUsers(); fetchApts(selectedProperty); fetchEvents(selectedProperty); getTasks()"
      aria-controls="Appointments"
      aria-selected="false"
      [class.active]="activeIndexs === 2">
      <i class="pi pi-calendar f-14 mr-1"></i>Calendar</a
    >
  </li>
  <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'my_task'" (click)="(property_id || insertedPropertyId) && getTasks()">
    <a
      class=""
      id="pills-Tasks-tab"
      data-bs-toggle="pill"
      data-bs-target="#Tasks"
      role="tab"
      (click)="openWorkTab(4)"
      aria-controls="Tasks"
      aria-selected="false"
      [class.active]="activeIndexs === 4">
      <img [src]="images?.listing_task" alt="lead" width="16px" height="16px" class="mr-1" />
      Tasks
      <p class="ml-2 a-head-badge" *ngIf="fullList?.length > 0">{{ fullList?.length }}</p>
    </a>
  </li>
  <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'listing_contact_relationship'">
    <a
      class=""
      id="pills-Related-tab"
      data-bs-toggle="pill"
      data-bs-target="#Related"
      role="Related"
      (click)="openWorkTab(5)"
      aria-controls="Related"
      aria-selected="false"
      [class.active]="activeIndexs === 5">
      <img [src]="images?.listing_related" alt="lead" width="16px" height="16px" class="mr-1" />
      Related
      <p class="ml-2 a-head-badge" *ngIf="attached_contacts?.length > 0">
        {{ attached_contacts?.length }}
      </p>
    </a>
  </li>
  <li
    class="nav-item cursor-pointer"
    role="presentation"
    *ngFlag="'approval'"
    (click)="(property_id || insertedPropertyId) && getApprovalComments(); getListingPermission()">
    <a
      class=""
      id="pills-approval-tab"
      data-bs-toggle="pill"
      data-bs-target="#approval"
      role="tab"
      (click)="openWorkTab(6)"
      aria-controls="approval"
      aria-selected="false"
      [class.active]="activeIndexs === 6">
      <img [src]="images?.approval_icon" alt="lead" width="16px" height="16px" class="mr-1" />
      Approval
      <p class="ml-2 a-head-badge" *ngIf="listingCommentUnresolved > 0">
        {{ listingCommentUnresolved }}
      </p>
    </a>
  </li>
  <ng-container *ngFlag="'commission'">
    <li
      class="nav-item cursor-pointer"
      role="presentation"
      *ngIf="
        userRole == 'administrators' ||
        userRole == 'master admin' ||
        userRole == 'operations manager' ||
        editProperty.controls['agent'].value === api.getUserId() ||
        editProperty.controls['secondaryagent'].value === api.getUserId()
      ">
      <a
        class=""
        id="pills-Commission-tab"
        data-bs-toggle="pill"
        data-bs-target="#Commission"
        role="tab"
        (click)="openWorkTab(7); getAgentListingCommission(); lmService.GetProjectList(); lmService.getProperties()"
        aria-controls="Commission"
        aria-selected="false"
        [class.active]="activeIndexs === 7">
        <img [src]="common_images?.conjunction_icon" alt="lead" width="16px" height="16px" class="mr-1" />
        Commission
      </a>
    </li>
  </ng-container>
  <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'listing_conjunction'">
    <a
      class=""
      id="pills-Conjunction-tab"
      data-bs-toggle="pill"
      data-bs-target="#Conjunction"
      role="tab"
      (click)="openWorkTab(8)"
      aria-controls="Conjunction"
      aria-selected="false"
      [class.active]="activeIndexs === 8">
      <img [src]="common_images?.conjunction_icon" alt="lead" width="16px" height="16px" class="mr-1" />
      Conjunction</a
    >
  </li>
  <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'notes'">
    <a
      class=""
      id="pills-notes-tab"
      data-bs-toggle="pill"
      data-bs-target="#notes"
      role="tab"
      (click)="openWorkTab(9)"
      aria-controls="notes"
      aria-selected="false"
      [class.active]="activeIndexs === 9">
      <img [src]="common_images?.notes" alt="lead" width="16px" height="16px" class="mr-1" />
      Notes</a
    >
  </li>
  <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'history'">
    <a
      class=""
      id="pills-History-tab"
      data-bs-toggle="pill"
      data-bs-target="#History"
      role="tab"
      (click)="openWorkTab(10); history_keyword = null"
      aria-controls="History"
      aria-selected="false"
      [class.active]="activeIndexs === 10">
      <img [src]="images?.listing_history" alt="lead" width="16px" height="16px" class="mr-1" />
      History</a
    >
  </li>
</ng-template>
